let mlb_sizeguide = [
  {
      man: [ 
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Queuille",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": 65
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 65,
              "s / 29": 67,
              "m / 31": 69,
              "l / 33": 71,
              "xl / 35": 73,
              "xxl": 75
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Gregoire",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 59,
              "l / 33": 62,
              "xl / 35": 65,
              "xxl": 68
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Henocque",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Reaumur",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69.5,
              "s / 29": 71.5,
              "m / 31": 73.5,
              "l / 33": 75.5,
              "xl / 35": 77.5,
              "xxl": 79.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Trésor",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 29.5,
              "s / 29": 31.5,
              "m / 31": 33.5,
              "l / 33": 35.5,
              "xl / 35": 37.5,
              "xxl": 39.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 100,
              "s / 29": 102,
              "m / 31": 104,
              "l / 33": 106,
              "xl / 35": 108,
              "xxl": 110
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Placide",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Ledru",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Arcole",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 32.5,
              "s / 29": 34.5,
              "m / 31": 36.5,
              "l / 33": 38.5,
              "xl / 35": 40.5,
              "xxl": 42.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 99,
              "s / 29": 102,
              "m / 31": 105,
              "l / 33": 108,
              "xl / 35": 111,
              "xxl": 114
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Mourlot",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 63.5,
              "s / 29": 65.5,
              "m / 31": 67.5,
              "l / 33": 69.5,
              "xl / 35": 71.5,
              "xxl": 73.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66.5,
              "s / 29": 68.5,
              "m / 31": 70.5,
              "l / 33": 72.5,
              "xl / 35": 74.5,
              "xxl": 76.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Lancereaux",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 72,
              "s / 29": 74,
              "m / 31": 76,
              "l / 33": 78,
              "xl / 35": 80,
              "xxl": 82
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 61,
              "s / 29": 62,
              "m / 31": 63,
              "l / 33": 64,
              "xl / 35": 65,
              "xxl": 66
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Sebasto Men",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": 49,
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 70,
              "xs / 27": 71,
              "s / 29": 72,
              "m / 31": 73,
              "l / 33": 74,
              "xl / 35": 75,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": 60,
              "xs / 27": 61,
              "s / 29": 62,
              "m / 31": 63,
              "l / 33": 64,
              "xl / 35": 65,
              "xxl": 66
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Fizbin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 56,
              "s / 29": 58,
              "m / 31": 60,
              "l / 33": 62,
              "xl / 35": 64,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 71,
              "m / 31": 73,
              "l / 33": 75,
              "xl / 35": 77,
              "xxl": 79
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Goldoni",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 50,
              "m / 31": 52,
              "l / 33": 54,
              "xl / 35": 56,
              "xxl": 58
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Mulot",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 54,
              "m / 31": 56,
              "l / 33": 58,
              "xl / 35": 60,
              "xxl": 62
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Privat",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 56,
              "m / 31": 58,
              "l / 33": 60,
              "xl / 35": 62,
              "xxl": 64
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Pronteau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 50,
              "m / 31": 52,
              "l / 33": 54,
              "xl / 35": 56,
              "xxl": 58
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Delepine",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 56,
              "s / 29": 58,
              "m / 31": 60,
              "l / 33": 62,
              "xl / 35": 64,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Guillaumin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 52,
              "m / 31": 54,
              "l / 33": 56,
              "xl / 35": 58,
              "xxl": 60
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Frenay",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 50,
              "m / 31": 52,
              "l / 33": 54,
              "xl / 35": 56,
              "xxl": 58
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Poitou",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47,
              "s / 29": 50,
              "m / 31": 53,
              "l / 33": 56,
              "xl / 35": 59,
              "xxl": 62
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 65.5,
              "s / 29": 67.5,
              "m / 31": 69.5,
              "l / 33": 71.5,
              "xl / 35": 73.5,
              "xxl": 75.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Popincourt",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47.5,
              "s / 29": 50.5,
              "m / 31": 53.5,
              "l / 33": 56.5,
              "xl / 35": 59.5,
              "xxl": 62.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Charonne",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 71,
              "m / 31": 73,
              "l / 33": 75,
              "xl / 35": 77,
              "xxl": 79
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Bretagne",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Montholon",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 70,
              "s / 29": 72,
              "m / 31": 74,
              "l / 33": 76,
              "xl / 35": 78,
              "xxl": 80
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Citeaux",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Roquette",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": 65
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67.5,
              "s / 29": 69.5,
              "m / 31": 71.5,
              "l / 33": 73.5,
              "xl / 35": 75.5,
              "xxl": 77.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "L'Aboukir",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 46,
              "s / 29": 49,
              "m / 31": 52,
              "l / 33": 55,
              "xl / 35": 58,
              "xxl": 61
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Rollin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": "48.5",
              "s / 29": "51.5",
              "m / 31": "54.5",
              "l / 33": "57.5",
              "xl / 35": "60.5",
              "xxl": "63.5"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Villemin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SAILOR SHIRT",
        "Category_fr": "MARINIÈRE",
        "Name": "La Colombier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 49,
              "s / 29": 52,
              "m / 31": 55,
              "l / 33": 58,
              "xl / 35": 61,
              "xxl": 64
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SAILOR SHIRT",
        "Category_fr": "MARINIÈRE",
        "Name": "La Montpar",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54.5,
              "s / 29": 57.5,
              "m / 31": 60.5,
              "l / 33": 63.5,
              "xl / 35": 66.5,
              "xxl": 69.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66.5,
              "s / 29": 68.5,
              "m / 31": 70.5,
              "l / 33": 72.5,
              "xl / 35": 74.5,
              "xxl": 76.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SAILOR SHIRT",
        "Category_fr": "MARINIÈRE",
        "Name": "La Dahomey",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 46,
              "s / 29": 49,
              "m / 31": 52,
              "l / 33": 55,
              "xl / 35": 58,
              "xxl": 61
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Verdeau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 44,
              "s / 29": 47,
              "m / 31": 50,
              "l / 33": 53,
              "xl / 35": 56,
              "xxl": 59
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Charlot",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 51,
              "m / 31": 54,
              "l / 33": 57,
              "xl / 35": 60,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le Sulpice",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51.5,
              "s / 29": 54.5,
              "m / 31": 57.5,
              "l / 33": 60.5,
              "xl / 35": 63.5,
              "xxl": 66.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68.5,
              "s / 29": 70.5,
              "m / 31": 72.5,
              "l / 33": 74.5,
              "xl / 35": 76.5,
              "xxl": 78.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Victoire",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68.5,
              "s / 29": 70.5,
              "m / 31": 72.5,
              "l / 33": 74.5,
              "xl / 35": 76.5,
              "xxl": 78.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Lobligeois",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50.5,
              "s / 29": 53.5,
              "m / 31": 56.5,
              "l / 33": 59.5,
              "xl / 35": 62.5,
              "xxl": 65.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Grand Cerf",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47,
              "s / 29": 49,
              "m / 31": 51,
              "l / 33": 53,
              "xl / 35": 55,
              "xxl": 57
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "L'Italie",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 64,
              "s / 29": 66,
              "m / 31": 68,
              "l / 33": 70,
              "xl / 35": 72,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Delépine",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 56,
              "s / 29": 58,
              "m / 31": 60,
              "l / 33": 62,
              "xl / 35": 64,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Lhomme",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 55,
              "s / 29": 57,
              "m / 31": 59,
              "l / 33": 61,
              "xl / 35": 63,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Nation",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 55,
              "s / 29": 58,
              "m / 31": 61,
              "l / 33": 64,
              "xl / 35": 67,
              "xxl": 70
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 76,
              "s / 29": 78,
              "m / 31": 80,
              "l / 33": 82,
              "xl / 35": 84,
              "xxl": 86
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 60,
              "s / 29": 61,
              "m / 31": 62,
              "l / 33": 63,
              "xl / 35": 64,
              "xxl": 65
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Malesherbes (collection)",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": null
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 73,
              "s / 29": 74,
              "m / 31": 75,
              "l / 33": 76,
              "xl / 35": 77,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 63.5,
              "s / 29": 64.5,
              "m / 31": 65.5,
              "l / 33": 66.5,
              "xl / 35": 67.5,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Malesherbes DYO",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47,
              "s / 29": 50,
              "m / 31": 53,
              "l / 33": 56,
              "xl / 35": 59,
              "xxl": null
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Germain",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 24,
              "s / 29": 24,
              "m / 31": 24,
              "l / 33": 25,
              "xl / 35": 26,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Morney",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 24,
              "s / 29": 24,
              "m / 31": 24,
              "l / 33": 25,
              "xl / 35": 26,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Rennes",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 51,
              "m / 31": 54,
              "l / 33": 57,
              "xl / 35": 60,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 64,
              "s / 29": 65,
              "m / 31": 66,
              "l / 33": 67,
              "xl / 35": 68,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Bonne Graine",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48.5,
              "s / 29": 51.5,
              "m / 31": 54.5,
              "l / 33": 57.5,
              "xl / 35": 60.5,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 75,
              "s / 29": 76,
              "m / 31": 77,
              "l / 33": 78,
              "xl / 35": 79,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "63.5",
              "s / 29": "64.5",
              "m / 31": "65.5",
              "l / 33": "66.5",
              "xl / 35": "67.5",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Froidevaux",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 73,
              "s / 29": 75,
              "m / 31": 77,
              "l / 33": 79,
              "xl / 35": 81,
              "xxl": 83
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Clignancourt",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 70,
              "m / 31": 71,
              "l / 33": 72,
              "xl / 35": 73,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Vanves",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 70,
              "m / 31": 71,
              "l / 33": 72,
              "xl / 35": 73,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Mouffetard",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 76,
              "s / 29": 77,
              "m / 31": 78,
              "l / 33": 79,
              "xl / 35": 80,
              "xxl": 81
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Villiers",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 49.5,
              "s / 29": 52.5,
              "m / 31": 55.5,
              "l / 33": 58.5,
              "xl / 35": 61.5,
              "xxl": 64.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Jemmapes",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": 50.5,
              "xs / 27": 52.5,
              "s / 29": 54.4,
              "m / 31": 57.5,
              "l / 33": 60.5,
              "xl / 35": 63.5,
              "xxl": 66.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 65.5,
              "xs / 27": 67.5,
              "s / 29": 69.5,
              "m / 31": 71.5,
              "l / 33": 73.5,
              "xl / 35": 75.5,
              "xxl": 77.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Crozatier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 49,
              "s / 29": 52,
              "m / 31": 55,
              "l / 33": 58,
              "xl / 35": 61,
              "xxl": 64
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "L'Amelot",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 76,
              "s / 29": 77,
              "m / 31": 78,
              "l / 33": 79,
              "xl / 35": 80,
              "xxl": 81
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "L'Aguesseau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 57,
              "s / 29": 58,
              "m / 31": 59,
              "l / 33": 60,
              "xl / 35": 61,
              "xxl": 62
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Duras",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": 81
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "L'Anglas",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50.5,
              "s / 29": 53.5,
              "m / 31": 56.5,
              "l / 33": 59.5,
              "xl / 35": 62.5,
              "xxl": 65.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Surène",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53.5,
              "s / 29": 55.5,
              "m / 31": 57.5,
              "l / 33": 59.5,
              "xl / 35": 61.5,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Maleville",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 54,
              "m / 31": 56,
              "l / 33": 58,
              "xl / 35": 60,
              "xxl": 62
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Jardin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 49,
              "s / 29": 51,
              "m / 31": 53,
              "l / 33": 55,
              "xl / 35": 57,
              "xxl": 59
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Treilhard",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52.5,
              "s / 29": 54.5,
              "m / 31": 56.5,
              "l / 33": 58.5,
              "xl / 35": 60.5,
              "xxl": 62.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Roch",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 69,
              "m / 31": 70,
              "l / 33": 71,
              "xl / 35": 72,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Derry",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Patureau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47,
              "s / 29": 50,
              "m / 31": 53,
              "l / 33": 56,
              "xl / 35": 59,
              "xxl": 62
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 71,
              "m / 31": 73,
              "l / 33": 75,
              "xl / 35": 77,
              "xxl": 79
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le St-Fargeau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 59,
              "l / 33": 62,
              "xl / 35": 65,
              "xxl": 68
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 65.5,
              "s / 29": 67.5,
              "m / 31": 69.5,
              "l / 33": 71.5,
              "xl / 35": 73.5,
              "xxl": 75.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Breteuil",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": "71/74",
              "s / 29": "73/76",
              "m / 31": "75/78",
              "l / 33": "77/80",
              "xl / 35": "79/82",
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "Le Summer Teddy",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 64,
              "m / 31": 65,
              "l / 33": 66,
              "xl / 35": 67,
              "xxl": 68
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 76,
              "s / 29": 77,
              "m / 31": 78,
              "l / 33": 79,
              "xl / 35": 80,
              "xxl": 81
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "Le Antelm",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 57,
              "s / 29": 60,
              "m / 31": 63,
              "l / 33": 66,
              "xl / 35": 69,
              "xxl": 72
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 67.5,
              "m / 31": 69,
              "l / 33": 70.5,
              "xl / 35": 72,
              "xxl": 73.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 65,
              "s / 29": 66,
              "m / 31": 67,
              "l / 33": 68,
              "xl / 35": 69,
              "xxl": 70
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Audin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53.5,
              "s / 29": 56.5,
              "m / 31": 59.5,
              "l / 33": 62.5,
              "xl / 35": 65.5,
              "xxl": 68.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 62,
              "s / 29": 63,
              "m / 31": 64,
              "l / 33": 65,
              "xl / 35": 66,
              "xxl": 67
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Hamelin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 47,
              "s / 29": 49,
              "m / 31": 51,
              "l / 33": 53,
              "xl / 35": 55,
              "xxl": 57
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66.5,
              "s / 29": 68.5,
              "m / 31": 70.5,
              "l / 33": 72.5,
              "xl / 35": 74.5,
              "xxl": 76.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le Valmy",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "s / m": 64,
              "l / xl": 67
            }
          },
          {
            "Longueur devant (cm)": {
              "s / m": 72,
              "l / xl": 74
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Soutine",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 34,
              "s / 29": 37,
              "m / 31": 40,
              "l / 33": 43,
              "xl / 35": 46,
              "xxl": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 99,
              "s / 29": 100,
              "m / 31": 101,
              "l / 33": 102,
              "xl / 35": 103,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Princes",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 35,
              "s / 29": 37,
              "m / 31": 39,
              "l / 33": 41,
              "xl / 35": 43,
              "xxl": 45
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 104,
              "s / 29": 105,
              "m / 31": 106,
              "l / 33": 107,
              "xl / 35": 108,
              "xxl": 109
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "L'Arcade",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 30,
              "s / 29": 33,
              "m / 31": 36,
              "l / 33": 39,
              "xl / 35": 42,
              "xxl": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 99,
              "s / 29": 100,
              "m / 31": 101,
              "l / 33": 102,
              "xl / 35": 103,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWIM SHORTS",
        "Category_fr": "SHORT DE BAIN",
        "Name": "Le Maillot",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": "-",
              "s / 29": 35,
              "m / 31": 38,
              "l / 33": 41,
              "xl / 35": 44,
              "xxl": 47
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": "-",
              "s / 29": 34,
              "m / 31": 35,
              "l / 33": 36,
              "xl / 35": 37,
              "xxl": 38
            }
          }
        ]
      },
      {
        "Category": "SHORTS",
        "Category_fr": "SHORTS",
        "Name": "Le Maine",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 35,
              "s / 29": 37,
              "m / 31": 39,
              "l / 33": 41,
              "xl / 35": 43,
              "xxl": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 50,
              "s / 29": 51,
              "m / 31": 52,
              "l / 33": 53,
              "xl / 35": 54,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Rochefoucauld",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 35,
              "s / 29": 37,
              "m / 31": 39,
              "l / 33": 41,
              "xl / 35": 43,
              "xxl": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 101,
              "s / 29": 102,
              "m / 31": 103,
              "l / 33": 104,
              "xl / 35": 105,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Havet",
        "sizes": [
          {
            "Tour de taille elastique (cm)": {
              "xs / 27": 33,
              "s / 29": 36,
              "m / 31": 39,
              "l / 33": 42,
              "xl / 35": 45,
              "xxl": 48
            }
          },
          {
            "Longueur total (cm)": {
              "xs / 27": 101,
              "s / 29": 102,
              "m / 31": 103,
              "l / 33": 104,
              "xl / 35": 105,
              "xxl": 106
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Migne",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 46.5,
              "s / 29": 49.5,
              "m / 31": 52.5,
              "l / 33": 55.5,
              "xl / 35": 58.5,
              "xxl": 61.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "L'Estrapade",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 73,
              "s / 29": 75,
              "m / 31": 77,
              "l / 33": 79,
              "xl / 35": 81,
              "xxl": 83
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le Faluere",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 65,
              "s / 29": 67,
              "m / 31": 69,
              "l / 33": 71,
              "xl / 35": 73,
              "xxl": 75
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le Bourgoin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 51,
              "s / 29": 53,
              "m / 31": 55,
              "l / 33": 57,
              "xl / 35": 59,
              "xxl": 61
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 62.5,
              "s / 29": 64.5,
              "m / 31": 66.5,
              "l / 33": 68.5,
              "xl / 35": 70.5,
              "xxl": 72.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Trentinian",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53.5,
              "s / 29": 56.5,
              "m / 31": 59.5,
              "l / 33": 62.5,
              "xl / 35": 65.5,
              "xxl": 68.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Grégoire",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 59,
              "l / 33": 62,
              "xl / 35": 65,
              "xxl": 68
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Guignier",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 34,
              " 28": 35.5,
              " 29": 37,
              " 30": 38.5,
              " 31": 40,
              " 32": 41.5,
              " 33": 43,
              " 34": 44.5,
              " 35": 46,
              " 36": 47.5
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 99,
              " 28": 99.5,
              " 29": 100,
              " 30": 100.5,
              " 31": 101,
              " 32": 101.5,
              " 33": 102,
              " 34": 102.5,
              " 35": 103,
              " 36": 103.5
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Loubet",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": "-",
              " 28": "-",
              " 29": "-",
              " 30": "-",
              " 31": "-",
              " 32": "-",
              " 33": "-",
              " 34": "-",
              " 35": "-",
              " 36": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": "-",
              " 28": "-",
              " 29": "-",
              " 30": "-",
              " 31": "-",
              " 32": "-",
              " 33": "-",
              " 34": "-",
              " 35": "-",
              " 36": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Perreur",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 36,
              " 28": 37,
              " 29": 38,
              " 30": 39,
              " 31": 40,
              " 32": 41,
              " 33": 42,
              " 34": 43,
              " 35": 44,
              " 36": 45
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 50,
              " 28": 50.5,
              " 29": 51,
              " 30": 51.5,
              " 31": 52,
              " 32": 52.5,
              " 33": 53,
              " 34": 53.5,
              " 35": 54,
              " 36": 54.5
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Tesson",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 36,
              " 28": 37,
              " 29": 38,
              " 30": 39,
              " 31": 40,
              " 32": 41,
              " 33": 42,
              " 34": 43,
              " 35": 44,
              " 36": 45
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 51,
              " 28": 51.5,
              " 29": 52,
              " 30": 52.5,
              " 31": 53,
              " 32": 53.5,
              " 33": 54,
              " 34": 54.5,
              " 35": 55,
              " 36": 55.5
            }
          }
        ]
      },
      {
        "Category": "SHORTS",
        "Category_fr": "SHORTS",
        "Name": "Le Beclere",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "xs / 27": 35,
              "s / 29": 37,
              "m / 31": 39,
              "l / 33": 41,
              "xl / 35": 43,
              "xxl": 45
            }
          },
          {
            "Longueur devant (cm)": {
              "xs / 27": 45,
              "s / 29": 47,
              "m / 31": 49,
              "l / 33": 51,
              "xl / 35": 53,
              "xxl": 55
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Chabrier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": 51,
              "xs / 27": 53,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 71.5,
              "xs / 27": 72,
              "s / 29": 72.5,
              "m / 31": 73,
              "l / 33": 73.5,
              "xl / 35": 74,
              "xxl": 74.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": 59.3,
              "xs / 27": 60.5,
              "s / 29": 61.8,
              "m / 31": 63,
              "l / 33": 64.3,
              "xl / 35": 65.5,
              "xxl": 66.8
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Falck",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 56,
              "s / 29": 59,
              "m / 31": 62,
              "l / 33": 65,
              "xl / 35": 68,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 78,
              "s / 29": 79,
              "m / 31": 80,
              "l / 33": 81,
              "xl / 35": 82,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 60,
              "s / 29": 61,
              "m / 31": 62,
              "l / 33": 63,
              "xl / 35": 64,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Mortemart",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 55,
              "s / 29": 58,
              "m / 31": 61,
              "l / 33": 64,
              "xl / 35": 67,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 72,
              "s / 29": 74,
              "m / 31": 76,
              "l / 33": 78,
              "xl / 35": 80,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 39.5,
              "s / 29": 40.5,
              "m / 31": 41.5,
              "l / 33": 42.5,
              "xl / 35": 43.5,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Audin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": 51.5,
              "xs / 27": 53.5,
              "s / 29": 56.5,
              "m / 31": 59.5,
              "l / 33": 62.5,
              "xl / 35": 65.5,
              "xxl": 68.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 64,
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": 61,
              "xs / 27": 62,
              "s / 29": 63,
              "m / 31": 64,
              "l / 33": 65,
              "xl / 35": 66,
              "xxl": 67
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Laurens",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 53.5,
              "s / 29": 56.5,
              "m / 31": 59.5,
              "l / 33": 62.5,
              "xl / 35": 65.5,
              "xxl": "-"
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 76,
              "s / 29": 77,
              "m / 31": 78,
              "l / 33": 79,
              "xl / 35": 80,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": 22,
              "s / 29": 23,
              "m / 31": 24,
              "l / 33": 25,
              "xl / 35": 26,
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "Le Beuret",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": 65
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 69,
              "xs / 27": 71,
              "s / 29": 73,
              "m / 31": 75,
              "l / 33": 77,
              "xl / 35": 79,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Ingold",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 50,
              "m / 31": 52,
              "l / 33": 54,
              "xl / 35": 56,
              "xxl": 58
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 68,
              "xs / 27": 70,
              "s / 29": 72,
              "m / 31": 74,
              "l / 33": 76,
              "xl / 35": 78,
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Vassilief",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": 48,
              "xs / 27": 50,
              "s / 29": 52,
              "m / 31": 54,
              "l / 33": 56,
              "xl / 35": 58,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": 68,
              "xs / 27": 70,
              "s / 29": 72,
              "m / 31": 74,
              "l / 33": 76,
              "xl / 35": "-",
              "xxl": "-"
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "DOWN COLLAR SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Laurens (CRUISE 25)",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 53.5,
              "s / 29": 56.5,
              "m / 31": 59.5,
              "l / 33": 62.5,
              "xl / 35": 65.5,
              "xxl": null
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 74,
              "s / 29": 75,
              "m / 31": 76,
              "l / 33": 77,
              "xl / 35": 78,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 22,
              "s / 29": 23,
              "m / 31": 24,
              "l / 33": 25,
              "xl / 35": 26,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "POLO SWEATER",
        "Category_fr": "POLO",
        "Name": "Le Bourdan",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 51,
              "s / 29": 53,
              "m / 31": 55,
              "l / 33": 57,
              "xl / 35": 59,
              "xxl": 61
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "POLO",
        "Category_fr": "POLO",
        "Name": "Le Chapu",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 51,
              "s / 29": 53,
              "m / 31": 55,
              "l / 33": 57,
              "xl / 35": 59,
              "xxl": 61
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "CARDIGAN",
        "Category_fr": "CARDIGAN",
        "Name": "Le Boissonade",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 50,
              "s / 29": 53,
              "m / 31": 56,
              "l / 33": 59,
              "xl / 35": 62,
              "xxl": 65
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 64,
              "s / 29": 66,
              "m / 31": 68,
              "l / 33": 70,
              "xl / 35": 72,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Clouet",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 64,
              "s / 29": 66,
              "m / 31": 68,
              "l / 33": 70,
              "xl / 35": 72,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATSHIRT",
        "Category_fr": "SWEATSHIRT",
        "Name": "Le Clodion",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48,
              "s / 29": 51,
              "m / 31": 54,
              "l / 33": 57,
              "xl / 35": 60,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 65,
              "s / 29": 67,
              "m / 31": 69,
              "l / 33": 71,
              "xl / 35": 73,
              "xxl": 75
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Chahu",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 48.5,
              "s / 29": 51.5,
              "m / 31": 54.5,
              "l / 33": 57.5,
              "xl / 35": 60.5,
              "xxl": 63.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 63,
              "s / 29": 65,
              "m / 31": 67,
              "l / 33": 69,
              "xl / 35": 71,
              "xxl": 73
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Chahu",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 55,
              "s / 29": 55,
              "m / 31": 57,
              "l / 33": 59,
              "xl / 35": 61,
              "xxl": 63
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 67,
              "m / 31": 69,
              "l / 33": 71,
              "xl / 35": 73,
              "xxl": 75
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Clairaut",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 52,
              "m / 31": 54,
              "l / 33": 56,
              "xl / 35": 58,
              "xxl": 60
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Tillier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 50,
              "s / 29": 52,
              "m / 31": 54,
              "l / 33": 56,
              "xl / 35": 58,
              "xxl": 60
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": "-",
              "xs / 27": "-",
              "s / 29": "-",
              "m / 31": "-",
              "l / 33": "-",
              "xl / 35": "-",
              "xxl": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Soutine",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 34,
              " 28": 35.5,
              " 29": 37,
              " 30": 38.5,
              " 31": 40,
              " 32": 41.5,
              " 33": 43,
              " 34": 44.5,
              " 35": 46,
              " 36": 47.5,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 99,
              " 28": 99,
              " 29": 100,
              " 30": 100,
              " 31": 101,
              " 32": 101,
              " 33": 102,
              " 34": 102,
              " 35": 103,
              " 36": 103,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "L'Arcade",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 33,
              " 28": 34,
              " 29": 34.5,
              " 30": 35.5,
              " 31": 36,
              " 32": 37.5,
              " 33": 38,
              " 34": 39,
              " 35": 40,
              " 36": 40.5,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 99,
              " 28": 99.5,
              " 29": 100,
              " 30": 100.5,
              " 31": 101,
              " 32": 101.5,
              " 33": 102,
              " 34": 102.5,
              " 35": 103,
              " 36": 103.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Rochefoucauld",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 35,
              " 28": 36,
              " 29": 37,
              " 30": 38,
              " 31": 39,
              " 32": 40,
              " 33": 41,
              " 34": 42,
              " 35": 43,
              " 36": 44,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 101,
              " 28": 101.5,
              " 29": 102,
              " 30": 102.5,
              " 31": 103,
              " 32": 103.5,
              " 33": 104,
              " 34": 104.5,
              " 35": 105,
              " 36": 105.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Prince",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 33,
              " 28": 34.5,
              " 29": 36,
              " 30": 37.5,
              " 31": 39,
              " 32": 40.5,
              " 33": 42,
              " 34": 43.5,
              " 35": 45,
              " 36": 46.5,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 103,
              " 28": 103.5,
              " 29": 104,
              " 30": 104.5,
              " 31": 105,
              " 32": 105.5,
              " 33": 106,
              " 34": 106.5,
              " 35": 107,
              " 36": 107.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Guigner",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 34,
              " 28": 35.5,
              " 29": 37,
              " 30": 38.5,
              " 31": 40,
              " 32": 41.5,
              " 33": 43,
              " 34": 44.5,
              " 35": 46,
              " 36": 47.5,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 99,
              " 28": 99.5,
              " 29": 100,
              " 30": 100.5,
              " 31": 101,
              " 32": 101.5,
              " 33": 102,
              " 34": 102.5,
              " 35": 103,
              " 36": 103.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "SHORT PANTS",
        "Category_fr": "SHORT",
        "Name": "Le Perreur",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 36,
              " 28": 37,
              " 29": 38,
              " 30": 39,
              " 31": 40,
              " 32": 41,
              " 33": 42,
              " 34": 43,
              " 35": 44,
              " 36": 45,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 50,
              " 28": 50.5,
              " 29": 51,
              " 30": 51.5,
              " 31": 52,
              " 32": 52.5,
              " 33": 53,
              " 34": 53.5,
              " 35": 54,
              " 36": 54.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "SHORT PANTS",
        "Category_fr": "SHORT",
        "Name": "Le Tesson",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 36,
              " 28": 37,
              " 29": 38,
              " 30": 39,
              " 31": 40,
              " 32": 41,
              " 33": 42,
              " 34": 43,
              " 35": 44,
              " 36": 45,
              " 37": "-"
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 51,
              " 28": 51.5,
              " 29": 52,
              " 30": 52.5,
              " 31": 53,
              " 32": 53.5,
              " 33": 54,
              " 34": 54.5,
              " 35": 55,
              " 36": 55.5,
              " 37": "-"
            }
          }
        ]
      },
      {
        "Category": "JOGGING",
        "Category_fr": "JOGGING",
        "Name": "Le Corbineau",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 34,
              " 28": "-",
              " 29": 36,
              " 30": "-",
              " 31": 38,
              " 32": "-",
              " 33": 40,
              " 34": "-",
              " 35": 42,
              " 36": "-",
              " 37": 44
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 101,
              " 28": "-",
              " 29": 103,
              " 30": "-",
              " 31": 105,
              " 32": "-",
              " 33": 107,
              " 34": "-",
              " 35": 109,
              " 36": "-",
              " 37": 111
            }
          }
        ]
      },
      {
        "Category": "SHORTS",
        "Category_fr": "SHORTS",
        "Name": "Le Herelle",
        "sizes": [
          {
            "Tour de taille (cm)": {
              " 27": 32.5,
              " 28": "-",
              " 29": 34.5,
              " 30": "-",
              " 31": 36.5,
              " 32": "-",
              " 33": 38.5,
              " 34": "-",
              " 35": 40.5,
              " 36": "-",
              " 37": 42.5
            }
          },
          {
            "Longueur devant (cm)": {
              " 27": 35.5,
              " 28": "-",
              " 29": 37.5,
              " 30": "-",
              " 31": 39.5,
              " 32": "-",
              " 33": 41.5,
              " 34": "-",
              " 35": 43.5,
              " 36": "-",
              " 37": 45.5
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Ziem",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 52,
              "s / 29": 55,
              "m / 31": 58,
              "l / 33": 61,
              "xl / 35": 64,
              "xxl": 67
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 69,
              "s / 29": 71,
              "m / 31": 73,
              "l / 33": 75,
              "xl / 35": 77,
              "xxl": 79
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Rops",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": "-",
              "xs / 27": 54,
              "s / 29": 56,
              "m / 31": 58,
              "l / 33": 60,
              "xl / 35": 62,
              "xxl": 64
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "Le Lemonnier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": 62,
              "m / 31": 62,
              "l / 33": 65,
              "xl / 35": 65,
              "xxl": null
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": 68,
              "m / 31": 68,
              "l / 33": 69.5,
              "xl / 35": 69.5,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": 64,
              "m / 31": 64,
              "l / 33": 65,
              "xl / 35": 65,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le St Fargeau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 59,
              "l / 33": 62,
              "xl / 35": 65,
              "xxl": 68
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "Le St Fargeau",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 53,
              "s / 29": 56,
              "m / 31": 59,
              "l / 33": 62,
              "xl / 35": 65,
              "xxl": 68
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 65.5,
              "s / 29": 67.5,
              "m / 31": 69.5,
              "l / 33": 71.5,
              "xl / 35": 73.5,
              "xxl": 75.5
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "POLO SHIRT",
        "Category_fr": "POLO",
        "Name": "L'Hillairet",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Baret",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 54,
              "s / 29": 57,
              "m / 31": 60,
              "l / 33": 63,
              "xl / 35": 66,
              "xxl": 69
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 67,
              "s / 29": 69,
              "m / 31": 71,
              "l / 33": 73,
              "xl / 35": 75,
              "xxl": 77
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Kelner",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 55,
              "s / 29": 57,
              "m / 31": 59,
              "l / 33": 61,
              "xl / 35": 63,
              "xxl": 65
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 64,
              "s / 29": 66,
              "m / 31": 68,
              "l / 33": 70,
              "xl / 35": 72,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Mawas",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 49,
              "s / 29": 51,
              "m / 31": 53,
              "l / 33": 55,
              "xl / 35": 57,
              "xxl": 59
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Balfournier",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 54.5,
              "s / 29": 56.5,
              "m / 31": 58.5,
              "l / 33": 60.5,
              "xl / 35": 62.5,
              "xxl": 64.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "CARDIGAN",
        "Category_fr": "CARDIGAN",
        "Name": "Le Farrere",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 56,
              "s / 29": 58,
              "m / 31": 60,
              "l / 33": 62,
              "xl / 35": 64,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 64,
              "s / 29": 66,
              "m / 31": 68,
              "l / 33": 70,
              "xl / 35": 72,
              "xxl": 74
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SWEATER",
        "Category_fr": "PULL",
        "Name": "Le Verlome",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 55.5,
              "s / 29": 57.5,
              "m / 31": 59.5,
              "l / 33": 61.5,
              "xl / 35": 63.5,
              "xxl": 65.5
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 66,
              "s / 29": 68,
              "m / 31": 70,
              "l / 33": 72,
              "xl / 35": 74,
              "xxl": 76
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "SHIRT",
        "Category_fr": "CHEMISE",
        "Name": "La Carnot",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": null
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": 73,
              "s / 29": 74,
              "m / 31": 75,
              "l / 33": 76,
              "xl / 35": 77,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 63.5,
              "s / 29": 64.5,
              "m / 31": 65.5,
              "l / 33": 66.5,
              "xl / 35": 67.5,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "T-SHIRT",
        "Category_fr": "TEE-SHIRT",
        "Name": "Le Chassaigne",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 51,
              "s / 29": 54,
              "m / 31": 57,
              "l / 33": 60,
              "xl / 35": 63,
              "xxl": 66
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": "-",
              "xs / 27": 68,
              "s / 29": 70,
              "m / 31": 72,
              "l / 33": 74,
              "xl / 35": 76,
              "xxl": 78
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Mister",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "27": null,
              "28": 38.25,
              "29": 39.5,
              "30": 40.75,
              "31": 40.75,
              "32": 42,
              "33": 43.25,
              "34": 44.25,
              "35": 45.75,
              "36": 47
            }
          },
          {
            "Longueur devant (cm)": {
              "27": null,
              "28": 105,
              "29": 105,
              "30": 105,
              "31": 105,
              "32": 105,
              "33": 105,
              "34": 105,
              "35": 105,
              "36": 110
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le All Day",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "27": null,
              "28": 39.25,
              "29": 40.5,
              "30": 41.75,
              "31": 41.75,
              "32": 43,
              "33": 44.25,
              "34": 45.5,
              "35": 46.75,
              "36": 48
            }
          },
          {
            "Longueur devant (cm)": {
              "27": null,
              "28": 101.5,
              "29": 102,
              "30": 102.5,
              "31": 102.5,
              "32": 103,
              "33": 103.5,
              "34": 104,
              "35": 104.5,
              "36": 105
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Old School",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "27": null,
              "28": 38,
              "29": 39.5,
              "30": 41,
              "31": 42.5,
              "32": 44,
              "33": 45.5,
              "34": 47,
              "35": 48.5,
              "36": 50
            }
          },
          {
            "Longueur devant (cm)": {
              "27": null,
              "28": 102.5,
              "29": 103,
              "30": 103.5,
              "31": 103.75,
              "32": 104,
              "33": 104.25,
              "34": 104.5,
              "35": 104.75,
              "36": 110
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le New School",
        "sizes": [
          {
            "Tour de taille (cm)": {
              "27": null,
              "28": 38,
              "29": 39.5,
              "30": 41,
              "31": 42.5,
              "32": 44,
              "33": 45.5,
              "34": 47,
              "35": 48.5,
              "36": 60
            }
          },
          {
            "Longueur devant (cm)": {
              "27": null,
              "28": 102.5,
              "29": 103,
              "30": 103.5,
              "31": 103.75,
              "32": 104,
              "33": 104.25,
              "34": 104.5,
              "35": 104.75,
              "36": 110
            }
          }
        ]
      },
      {
        "Category": "PANTS",
        "Category_fr": "PANTALON",
        "Name": "Le Wide & Comfy",
        "sizes": [
          {
            "Tour de taille elastique (cm)": {
              "xs / 27": 37,
              "s / 29": 39,
              "m / 31": 41,
              "l / 33": 43,
              "xl / 35": 45,
              "xxl / 36": 47
            }
          },
          {
            "Longueur total (cm)": {
              "xs / 27": 105,
              "s / 29": 106.5,
              "m / 31": 108,
              "l / 33": 109.5,
              "xl / 35": 111,
              "xxl / 36": 112.5
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Transport",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 43,
              "s / 29": 45,
              "m / 31": 48,
              "l / 33": 51,
              "xl / 35": 53,
              "xxl": 56
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 81,
              "s / 29": 84,
              "m / 31": 86,
              "l / 33": 89,
              "xl / 35": 91,
              "xxl": 94
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Spey",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 43,
              "s / 29": 45,
              "m / 31": 48,
              "l / 33": 51,
              "xl / 35": 53,
              "xxl": 56
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 81,
              "s / 29": 84,
              "m / 31": 86,
              "l / 33": 89,
              "xl / 35": 91,
              "xxl": 94
            }
          }
        ]
      },
      {
        "Category": "JACKET",
        "Category_fr": "VESTE",
        "Name": "La Reelin",
        "sizes": [
          {
            "Demi-tour de poitrine (cm à plat)": {
              "xxs": null,
              "xs / 27": 43,
              "s / 29": 45,
              "m / 31": 48,
              "l / 33": 51,
              "xl / 35": 53,
              "xxl": 56
            }
          },
          {
            "Longueur total (cm)": {
              "xxs": null,
              "xs / 27": null,
              "s / 29": null,
              "m / 31": null,
              "l / 33": null,
              "xl / 35": null,
              "xxl": null
            }
          },
          {
            "Longueur de manches (cm)": {
              "xxs": null,
              "xs / 27": 81,
              "s / 29": 84,
              "m / 31": 86,
              "l / 33": 89,
              "xl / 35": 91,
              "xxl": 94
            }
          }
        ]
      }
    ],
      woman: [
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Gesvres",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 57,
                "s / 26": 60,
                "m / 28": 63,
                "l / 30": 66,
                "xl / 32": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 58,
                "xl / 32": 60
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Thure",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 52,
                "s / 26": 52,
                "m / 28": 55,
                "l / 30": 55,
                "xl / 32": null
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 60,
                "s / 26": 60,
                "m / 28": 62,
                "l / 30": 62,
                "xl / 32": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 60,
                "s / 26": 60,
                "m / 28": 61,
                "l / 30": 61,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "TOP",
          "Category_fr": "TOP",
          "Name": "Le Gravilliers",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 40,
                "s / 26": 43,
                "m / 28": 46,
                "l / 30": 49,
                "xl / 32": 52
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 48,
                "s / 26": 50,
                "m / 28": 52,
                "l / 30": 54,
                "xl / 32": 56
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Joffrin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 57,
                "l / 33": 60,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 55.5,
                "s / 29": 58.5,
                "m / 31": 61.5,
                "l / 33": 64.5,
                "xl / 35": 67.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le St Ange",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 61,
                "m / 31": 64,
                "l / 33": 67,
                "xl / 35": 70
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Treffouel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 38,
                "s / 29": 40,
                "m / 31": 42,
                "l / 33": 44,
                "xl / 35": 46
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 60,
                "m / 31": 62,
                "l / 33": 64,
                "xl / 35": 66
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Laupretre",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 58,
                "m / 31": 60,
                "l / 33": 62,
                "xl / 35": 64
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Lebaudy",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 36,
                "s / 29": 39,
                "m / 31": 42,
                "l / 33": 45,
                "xl / 35": 48
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 52,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 58,
                "xl / 35": 60
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Marette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 36.5,
                "s / 29": 39.5,
                "m / 31": 42.5,
                "l / 33": 45.5,
                "xl / 35": 48.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 60,
                "m / 31": 62,
                "l / 33": 64,
                "xl / 35": 66
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Rouche",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 33,
                "s / 29": 36,
                "m / 31": 39,
                "l / 33": 42,
                "xl / 35": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 51.5,
                "s / 29": 53.5,
                "m / 31": 55.5,
                "l / 33": 57.5,
                "xl / 35": 59.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Kossuth",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 61,
                "s / 29": 63,
                "m / 31": 65,
                "l / 33": 67,
                "xl / 35": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 65.5,
                "s / 29": 67.5,
                "m / 31": 69.5,
                "l / 33": 71.5,
                "xl / 35": 73.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Sebasto Women",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 49,
                "s / 29": 52,
                "m / 31": 55,
                "l / 33": 58,
                "xl / 35": 61
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 70,
                "s / 29": 71,
                "m / 31": 72,
                "l / 33": 73,
                "xl / 35": 74
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 60,
                "s / 29": 61,
                "m / 31": 62,
                "l / 33": 63,
                "xl / 35": 64
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Ayme",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 46.5,
                "s / 29": 49.5,
                "m / 31": 52.5,
                "l / 33": 55.5,
                "xl / 35": 58.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54,
                "s / 29": 56,
                "m / 31": 58,
                "l / 33": 60,
                "xl / 35": 62
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Barrault",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48,
                "s / 29": 51,
                "m / 31": 54,
                "l / 33": 57,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Berger",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 45,
                "s / 29": 48,
                "m / 31": 51,
                "l / 33": 54,
                "xl / 35": 57
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 50.5,
                "s / 29": 52.5,
                "m / 31": 54.5,
                "l / 33": 56.5,
                "xl / 35": 58.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Bernier",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 47,
                "s / 29": 50,
                "m / 31": 53,
                "l / 33": 56,
                "xl / 35": 59
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 60,
                "s / 29": 62,
                "m / 31": 64,
                "l / 33": 66,
                "xl / 35": 68
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Marti",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 39,
                "s / 29": 42,
                "m / 31": 45,
                "l / 33": 48,
                "xl / 35": 51
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 46.5,
                "s / 29": 48.5,
                "m / 31": 50.5,
                "l / 33": 52.5,
                "xl / 35": 54.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Lafay",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 40,
                "s / 29": 43,
                "m / 31": 46,
                "l / 33": 49,
                "xl / 35": 52
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 47,
                "s / 29": 49,
                "m / 31": 51,
                "l / 33": 53,
                "xl / 35": 55
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Miribel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50.5,
                "s / 29": 53.5,
                "m / 31": 56.5,
                "l / 33": 59.5,
                "xl / 35": 62.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 53.5,
                "s / 29": 55.5,
                "m / 31": 57.5,
                "l / 33": 59.5,
                "xl / 35": 61.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Regnault",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44,
                "s / 29": 47,
                "m / 31": 50,
                "l / 33": 53,
                "xl / 35": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54,
                "s / 29": 56,
                "m / 31": 58,
                "l / 33": 60,
                "xl / 35": 62
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Popincourt",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 47,
                "s / 29": 50,
                "m / 31": 53,
                "l / 33": 56,
                "xl / 35": 59
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Réaumur",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50,
                "s / 29": 53,
                "m / 31": 56,
                "l / 33": 59,
                "xl / 35": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 60,
                "s / 29": 62,
                "m / 31": 64,
                "l / 33": 66,
                "xl / 35": 68
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Tolain",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 54,
                "s / 29": 57,
                "m / 31": 60,
                "l / 33": 63,
                "xl / 35": 66
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 48.5,
                "s / 29": 50.5,
                "m / 31": 52.5,
                "l / 33": 54.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Montherlant",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 40.5,
                "s / 29": 43.5,
                "m / 31": 46.5,
                "l / 33": 49.5,
                "xl / 35": 52.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58.5,
                "s / 29": 60.5,
                "m / 31": 62.5,
                "l / 33": 64.5,
                "xl / 35": 66.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Soufflot",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 47,
                "s / 29": 50,
                "m / 31": 53,
                "l / 33": 56,
                "xl / 35": 59
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 60,
                "m / 31": 62,
                "l / 33": 64,
                "xl / 35": 66
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Herran",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48.5,
                "s / 29": 51.5,
                "m / 31": 54.5,
                "l / 33": 57.5,
                "xl / 35": 60.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Ledru",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50,
                "s / 29": 53,
                "m / 31": 56,
                "l / 33": 59,
                "xl / 35": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 62,
                "m / 31": 65,
                "l / 33": 68,
                "xl / 35": 71
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Jacquemont",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52.5,
                "s / 29": 55.5,
                "m / 31": 58.5,
                "l / 33": 61.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 59,
                "m / 31": 62,
                "l / 33": 65,
                "xl / 35": 68
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Verdeau",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 41,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 50,
                "xl / 35": 53
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Vasselon",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 35,
                "s / 29": 38,
                "m / 31": 41,
                "l / 33": 44,
                "xl / 35": 47
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 52,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 58,
                "xl / 35": 60
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Mondovie",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 58,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 58,
                "m / 31": 60,
                "l / 33": 62,
                "xl / 35": 64
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Poitou",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44,
                "s / 29": 47,
                "m / 31": 50,
                "l / 33": 53,
                "xl / 35": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Saint Mich",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 43,
                "s / 29": 46,
                "m / 31": 49,
                "l / 33": 52,
                "xl / 35": 55
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Charlot",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 43,
                "s / 29": 46,
                "m / 31": 49,
                "l / 33": 52,
                "xl / 35": 55
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Sibuet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 41,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 50,
                "xl / 35": 53
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": "58.5",
                "s / 29": "60.5",
                "m / 31": "62.5",
                "l / 33": "64.5",
                "xl / 35": "66.5"
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "La Chalon",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 84,
                "s / 29": 86,
                "m / 31": 88,
                "l / 33": 90,
                "xl / 35": 92
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Champs",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 31,
                "s / 29": 34,
                "m / 31": 37,
                "l / 33": 40,
                "xl / 35": 43
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 53,
                "s / 29": 55,
                "m / 31": 57,
                "l / 33": 59,
                "xl / 35": 61
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "BODYSUIT",
          "Category_fr": "BODY",
          "Name": "Le Clichy",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 32.5,
                "s / 29": 35.5,
                "m / 31": 38.5,
                "l / 33": 41.5,
                "xl / 35": 44.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 70.5,
                "s / 29": 72.5,
                "m / 31": 74.5,
                "l / 33": 76.5,
                "xl / 35": 78.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Charonne",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48,
                "s / 29": 50,
                "m / 31": 52,
                "l / 33": 54,
                "xl / 35": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 58,
                "m / 31": 60,
                "l / 33": 62,
                "xl / 35": 64
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Colombier",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 41,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 50,
                "xl / 35": 53
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 60,
                "m / 31": 62,
                "l / 33": 64,
                "xl / 35": 66
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Sèvres",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 42,
                "s / 29": 45,
                "m / 31": 48,
                "l / 33": 51,
                "xl / 35": 54
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 58,
                "s / 29": 60,
                "m / 31": 62,
                "l / 33": 64,
                "xl / 35": 66
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Montpar",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54.5,
                "s / 29": 57.5,
                "m / 31": 60.5,
                "l / 33": 63.5,
                "xl / 35": 66.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Seine",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52.5,
                "s / 29": 55.5,
                "m / 31": 58.5,
                "l / 33": 61.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 87,
                "s / 29": 89,
                "m / 31": 91,
                "l / 33": 93,
                "xl / 35": 95
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Tolbiac",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44.5,
                "s / 29": 47.5,
                "m / 31": 50.5,
                "l / 33": 53.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 47,
                "s / 29": 49,
                "m / 31": 51,
                "l / 33": 53,
                "xl / 35": 55
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Monceau",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 42.5,
                "s / 29": 45.5,
                "m / 31": 48.5,
                "l / 33": 51.5,
                "xl / 35": 54.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 83,
                "s / 29": 85,
                "m / 31": 87,
                "l / 33": 89,
                "xl / 35": 91
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Lachaise",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 34,
                "s / 29": 37,
                "m / 31": 40,
                "l / 33": 43,
                "xl / 35": 46
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54,
                "s / 29": 56,
                "m / 31": 58,
                "l / 33": 60,
                "xl / 35": 62
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Villiers",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": "44.5",
                "s / 29": "47.5",
                "m / 31": "50.5",
                "l / 33": "53.5",
                "xl / 35": "56.5"
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Château",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52.5,
                "s / 29": 55.5,
                "m / 31": 58.5,
                "l / 33": 61.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "L'Alésia",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 48.5,
                "s / 29": 50.5,
                "m / 31": 52.5,
                "l / 33": 54.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Croquette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 38,
                "s / 29": 40,
                "m / 31": 42,
                "l / 33": 44,
                "xl / 35": 46
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 44,
                "s / 29": 46,
                "m / 31": 48,
                "l / 33": 50,
                "xl / 35": 52
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "BODYSUIT",
          "Category_fr": "BODY",
          "Name": "Le Progrès",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 32.5,
                "s / 29": 35.5,
                "m / 31": 38.5,
                "l / 33": 41.5,
                "xl / 35": 44.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 70,
                "s / 29": 72,
                "m / 31": 74,
                "l / 33": 76,
                "xl / 35": 78
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Folies",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 36,
                "s / 29": 39,
                "m / 31": 42,
                "l / 33": 45,
                "xl / 35": 48
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54.5,
                "s / 29": 56.5,
                "m / 31": 58.5,
                "l / 33": 60.5,
                "xl / 35": 62.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Galepi",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 31,
                "s / 29": 34,
                "m / 31": 37,
                "l / 33": 40,
                "xl / 35": 43
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57.5,
                "s / 29": 59.5,
                "m / 31": 61.5,
                "l / 33": 63.5,
                "xl / 35": 65.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Royale",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 36.5,
                "s / 29": 39.5,
                "m / 31": 42.5,
                "l / 33": 45.5,
                "xl / 35": 48.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 48.5,
                "s / 29": 50.5,
                "m / 31": 52.5,
                "l / 33": 54.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Mace",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 45,
                "s / 29": 48,
                "m / 31": 51,
                "l / 33": 54,
                "xl / 35": 57
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 60,
                "s / 29": 62,
                "m / 31": 64,
                "l / 33": 66,
                "xl / 35": 68
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Brady",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 42,
                "s / 29": 44,
                "m / 31": 46,
                "l / 33": 48,
                "xl / 35": 50
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 132,
                "s / 29": 134,
                "m / 31": 136,
                "l / 33": 138,
                "xl / 35": 140
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Régnault",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 45.5,
                "s / 29": 48.5,
                "m / 31": 51.5,
                "l / 33": 54.5,
                "xl / 35": 57.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 54,
                "s / 29": 56,
                "m / 31": 58,
                "l / 33": 60,
                "xl / 35": 62
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "L'Étoile",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 45,
                "s / 29": 48,
                "m / 31": 51,
                "l / 33": 54,
                "xl / 35": 57
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 55,
                "s / 29": 57,
                "m / 31": 59,
                "l / 33": 61,
                "xl / 35": 63
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Choiseul",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44,
                "s / 29": 46,
                "m / 31": 48,
                "l / 33": 50,
                "xl / 35": 52
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Cité",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 58,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Soupir",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 54.5,
                "s / 29": 56,
                "m / 31": 57.5,
                "l / 33": 59,
                "xl / 35": 60.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 84.5,
                "s / 29": 86.5,
                "m / 31": 88.5,
                "l / 33": 90.5,
                "xl / 35": 92.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Vivienne",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 55,
                "s / 29": 57,
                "m / 31": 59,
                "l / 33": 61,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 68.5,
                "s / 29": 70.5,
                "m / 31": 72.5,
                "l / 33": 74.5,
                "xl / 35": 76.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Daguerre",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 41.5,
                "s / 29": 43.5,
                "m / 31": 45.5,
                "l / 33": 47.5,
                "xl / 35": 49.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 118,
                "s / 29": 120,
                "m / 31": 122,
                "l / 33": 124,
                "xl / 35": 126
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Picpus",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 31,
                "s / 29": 34,
                "m / 31": 37,
                "l / 33": 40,
                "xl / 35": 43
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56.5,
                "s / 29": 58.5,
                "m / 31": 60.5,
                "l / 33": 62.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Baron",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 59,
                "xl / 35": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 145,
                "s / 29": 147,
                "m / 31": 149,
                "l / 33": 151,
                "xl / 35": 153
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 55,
                "s / 29": 56,
                "m / 31": 57,
                "l / 33": 58,
                "xl / 35": 59
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Saint-Ger",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 57,
                "l / 33": 60,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 73,
                "s / 29": 75,
                "m / 31": 77,
                "l / 33": 79,
                "xl / 35": 81
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "56.5",
                "s / 29": "57.5",
                "m / 31": "58.5",
                "l / 33": "59.5",
                "xl / 35": "60.5"
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Temple",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 45,
                "s / 29": 47,
                "m / 31": 49,
                "l / 33": 51,
                "xl / 35": 53
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 65,
                "s / 29": 67,
                "m / 31": 69,
                "l / 33": 71,
                "xl / 35": 73
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 62,
                "s / 29": 63,
                "m / 31": 64,
                "l / 33": 65,
                "xl / 35": 66
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Saint-Denis",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 57,
                "l / 33": 60,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 71.5,
                "s / 29": 73.5,
                "m / 31": 75.5,
                "l / 33": 77.5,
                "xl / 35": 79.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "57.25",
                "s / 29": 58,
                "m / 31": "58.75",
                "l / 33": "59.5",
                "xl / 35": "60.25"
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Caire",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 47,
                "s / 29": 50,
                "m / 31": 53,
                "l / 33": 56,
                "xl / 35": 59
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 62,
                "s / 29": 64,
                "m / 31": 66,
                "l / 33": 68,
                "xl / 35": 70
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 16,
                "s / 29": 17,
                "m / 31": 18,
                "l / 33": 19,
                "xl / 35": 20
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Queen",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50,
                "s / 29": 53,
                "m / 31": 56,
                "l / 33": 59,
                "xl / 35": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 57,
                "m / 31": 58,
                "l / 33": 59,
                "xl / 35": 60
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 74,
                "s / 29": 75,
                "m / 31": 76,
                "l / 33": 77,
                "xl / 35": 78
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Barbette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 41.5,
                "s / 29": 43.5,
                "m / 31": 45.5,
                "l / 33": 47.5,
                "xl / 35": 49.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 113,
                "s / 29": 115,
                "m / 31": 117,
                "l / 33": 119,
                "xl / 35": 121
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Cardinet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 39,
                "s / 29": 42,
                "m / 31": 45,
                "l / 33": 48,
                "xl / 35": 51
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Dallery",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 49,
                "s / 29": 51,
                "m / 31": 53,
                "l / 33": 55,
                "xl / 35": 57
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 115,
                "s / 29": 117,
                "m / 31": 119,
                "l / 33": 121,
                "xl / 35": 123
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "L'Elzévir",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 36,
                "s / 29": 38,
                "m / 31": 40,
                "l / 33": 42,
                "xl / 35": 44
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 88,
                "s / 29": 90,
                "m / 31": 92,
                "l / 33": 94,
                "xl / 35": 96
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "BODYSUIT",
          "Category_fr": "BODY",
          "Name": "Le Gobert",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 32.5,
                "s / 29": 35.5,
                "m / 31": 38.5,
                "l / 33": 41.5,
                "xl / 35": 44.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 72.5,
                "s / 29": 74.5,
                "m / 31": 76.5,
                "l / 33": 78.5,
                "xl / 35": 80.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Jaurès",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44,
                "s / 29": 47,
                "m / 31": 50,
                "l / 33": 53,
                "xl / 35": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 61,
                "s / 29": 63,
                "m / 31": 65,
                "l / 33": 67,
                "xl / 35": 69
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Maubeuge",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 54,
                "s / 29": 57,
                "m / 31": 60,
                "l / 33": 63,
                "xl / 35": 66
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57.5,
                "s / 29": 59.5,
                "m / 31": 61.5,
                "l / 33": 63.5,
                "xl / 35": 65.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "L'Orsel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 39,
                "s / 29": 42,
                "m / 31": 45,
                "l / 33": 48,
                "xl / 35": 51
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Riberolle",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 35.5,
                "s / 29": 38.5,
                "m / 31": 41.5,
                "l / 33": 44.5,
                "xl / 35": 47.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 34,
                "s / 29": 36,
                "m / 31": 38,
                "l / 33": 40,
                "xl / 35": 42
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Sedaine",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48,
                "s / 29": 51,
                "m / 31": 54,
                "l / 33": 57,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 59,
                "s / 29": 61,
                "m / 31": 63,
                "l / 33": 65,
                "xl / 35": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "BODYSUIT",
          "Category_fr": "BODY",
          "Name": "Le Progrès",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 32.5,
                "s / 29": 35.5,
                "m / 31": 38.5,
                "l / 33": 41.5,
                "xl / 35": 44.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 70,
                "s / 29": 72,
                "m / 31": 74,
                "l / 33": 76,
                "xl / 35": 78
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Reynaud",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 53,
                "s / 29": 55,
                "m / 31": 57,
                "l / 33": 59,
                "xl / 35": 61
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 153,
                "s / 29": 155,
                "m / 31": 157,
                "l / 33": 159,
                "xl / 35": 161
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 18,
                "s / 29": 19,
                "m / 31": 20,
                "l / 33": 21,
                "xl / 35": 22
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Montsouris",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 57,
                "l / 33": 60,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 114,
                "s / 29": 115,
                "m / 31": 116,
                "l / 33": 117,
                "xl / 35": 118
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 59,
                "s / 29": 60,
                "m / 31": 61,
                "l / 33": 62,
                "xl / 35": 63
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Laborde",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 43,
                "s / 29": 45,
                "m / 31": 47,
                "l / 33": 49,
                "xl / 35": 51
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 132.5,
                "s / 29": 134.5,
                "m / 31": 136.5,
                "l / 33": 138.5,
                "xl / 35": 140.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "BODYSUIT",
          "Category_fr": "BODY",
          "Name": "L'Astorg",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 33.5,
                "s / 29": 36.5,
                "m / 31": 39.5,
                "l / 33": 42.5,
                "xl / 35": 45.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 72,
                "s / 29": 74,
                "m / 31": 76,
                "l / 33": 78,
                "xl / 35": 80
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Boétie",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 34.5,
                "s / 29": 37.5,
                "m / 31": 40.5,
                "l / 33": 43.5,
                "xl / 35": 46.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 37,
                "s / 29": 39,
                "m / 31": 41,
                "l / 33": 43,
                "xl / 35": 45
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Thabor",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 53,
                "s / 29": 55,
                "m / 31": 57,
                "l / 33": 59,
                "xl / 35": 61
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 146,
                "s / 29": 148,
                "m / 31": 150,
                "l / 33": 152,
                "xl / 35": 154
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 57,
                "s / 29": 58,
                "m / 31": 59,
                "l / 33": 60,
                "xl / 35": 61
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "L'Abbans",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 52,
                "s / 29": 54,
                "m / 31": 56,
                "l / 33": 58,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 57,
                "s / 29": 59,
                "m / 31": 61,
                "l / 33": 63,
                "xl / 35": 65
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Rivière",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 56.5,
                "s / 29": 58.5,
                "m / 31": 60.5,
                "l / 33": 62.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 60,
                "s / 29": 62,
                "m / 31": 64,
                "l / 33": 66,
                "xl / 35": 68
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Mondovi",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50,
                "s / 29": 52,
                "m / 31": 54,
                "l / 33": 56,
                "xl / 35": 58
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56,
                "s / 29": 58,
                "m / 31": 60,
                "l / 33": 62,
                "xl / 35": 64
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Bainville",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 50,
                "s / 29": 53,
                "m / 31": 56,
                "l / 33": 59,
                "xl / 35": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 69,
                "s / 29": 71,
                "m / 31": 73,
                "l / 33": 75,
                "xl / 35": 77
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "La Tandou",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 42,
                "s / 29": 45,
                "m / 31": 48,
                "l / 33": 51,
                "xl / 35": 54
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Loutil",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 55,
                "s / 29": 58,
                "m / 31": 61,
                "l / 33": 64,
                "xl / 35": 67
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 77,
                "s / 29": 79,
                "m / 31": 81,
                "l / 33": 83,
                "xl / 35": 85
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 62,
                "s / 29": 63,
                "m / 31": 64,
                "l / 33": 65,
                "xl / 35": 66
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Chanute",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48,
                "s / 29": 51,
                "m / 31": 54,
                "l / 33": 57,
                "xl / 35": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 62,
                "s / 29": 64,
                "m / 31": 66,
                "l / 33": 68,
                "xl / 35": 70
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": 60,
                "s / 29": 61,
                "m / 31": 62,
                "l / 33": 63,
                "xl / 35": 64
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Valhubert",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 44.5,
                "s / 29": 47.5,
                "m / 31": 50.5,
                "l / 33": 53.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 52,
                "s / 29": 53,
                "m / 31": 54,
                "l / 33": 55,
                "xl / 35": 56
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Gaste",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 48.5,
                "s / 29": 50.5,
                "m / 31": 52.5,
                "l / 33": 54.5,
                "xl / 35": 56.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 52.5,
                "s / 29": 54.5,
                "m / 31": 56.5,
                "l / 33": 58.5,
                "xl / 35": 60.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Farge",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 35,
                "s / 29": 38,
                "m / 31": 41,
                "l / 33": 44,
                "xl / 35": 47
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 56.5,
                "s / 29": 58.5,
                "m / 31": 60.5,
                "l / 33": 62.5,
                "xl / 35": 64.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Armand",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 57,
                "l / 33": 60,
                "xl / 35": 63
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 53.5,
                "s / 29": 55.5,
                "m / 31": 57.5,
                "l / 33": 59.5,
                "xl / 35": 61.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Sabotiers",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 53,
                "s / 26": 56,
                "m / 28": 59,
                "l / 30": 62,
                "xl / 32": 65,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Focillon",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 53,
                "s / 26": 56,
                "m / 28": 59,
                "l / 30": 62,
                "xl / 32": 65,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Venaissin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 42,
                "s / 26": 45,
                "m / 28": 48,
                "l / 30": 51,
                "xl / 32": 54,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 49.5,
                "s / 26": 51.5,
                "m / 28": 53.5,
                "l / 30": 55.5,
                "xl / 32": 57.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "POLO SHIRT",
          "Category_fr": "POLO",
          "Name": "Le Marces",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 48,
                "s / 26": 51,
                "m / 28": 54,
                "l / 30": 57,
                "xl / 32": 60,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 49,
                "s / 26": 51,
                "m / 28": 53,
                "l / 30": 55,
                "xl / 32": 57,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SHORTS",
          "Category_fr": "SHORTS",
          "Name": "Le Trousseau",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 35,
                "s / 26": 37,
                "m / 28": 39,
                "l / 30": 41,
                "xl / 32": 43,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 34.5,
                "s / 26": 35.5,
                "m / 28": 36.5,
                "l / 30": 37.5,
                "xl / 32": 38.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Albinoni",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 41.5,
                "s / 26": 44.5,
                "m / 28": 47.5,
                "l / 30": 50.5,
                "xl / 32": 53.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 85.5,
                "s / 26": 87.5,
                "m / 28": 89.5,
                "l / 30": 91.5,
                "xl / 32": 93.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Gagliardini",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 83,
                "s / 26": 85,
                "m / 28": 87,
                "l / 30": 89,
                "xl / 32": 91,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Marette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 36.5,
                "s / 26": 39.5,
                "m / 28": 42.5,
                "l / 30": 45.5,
                "xl / 32": 48.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 56.5,
                "s / 26": 58.5,
                "m / 28": 60.5,
                "l / 30": 62.5,
                "xl / 32": 64.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Affre",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 35.5,
                "s / 26": 38.5,
                "m / 28": 41.5,
                "l / 30": 44.5,
                "xl / 32": 47.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 45,
                "s / 26": 47,
                "m / 28": 49,
                "l / 30": 51,
                "xl / 32": 53,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "POLO SHIRT",
          "Category_fr": "POLO",
          "Name": "Le Agar",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 34,
                "s / 26": 37,
                "m / 28": 40,
                "l / 30": 43,
                "xl / 32": 46,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 47.5,
                "s / 26": 49.5,
                "m / 28": 51.5,
                "l / 30": 53.5,
                "xl / 32": 55.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Château",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 47.5,
                "s / 26": 50.5,
                "m / 28": 53.5,
                "l / 30": 56.5,
                "xl / 32": 59.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 58,
                "s / 26": 60,
                "m / 28": 62,
                "l / 30": 64,
                "xl / 32": 66,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Vitruve",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 32,
                "s / 26": 35,
                "m / 28": 38,
                "l / 30": 41,
                "xl / 32": 44,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 54.5,
                "s / 26": 56.5,
                "m / 28": 58.5,
                "l / 30": 60.5,
                "xl / 32": 62.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "POLO SHIRT",
          "Category_fr": "POLO",
          "Name": "Le Rouche",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 33,
                "s / 26": 36,
                "m / 28": 39,
                "l / 30": 42,
                "xl / 32": 45,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 51.5,
                "s / 26": 53.5,
                "m / 28": 55.5,
                "l / 30": 57.5,
                "xl / 32": 59.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Abel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 46,
                "s / 26": 49,
                "m / 28": 52,
                "l / 30": 55,
                "xl / 32": 58,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 63,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Lavy",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 48,
                "s / 26": 51,
                "m / 28": 54,
                "l / 30": 57,
                "xl / 32": 60,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 53.5,
                "s / 26": 56.5,
                "m / 28": 59.5,
                "l / 30": 62.5,
                "xl / 32": 65.5,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Samain",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 37,
                "s / 26": 40,
                "m / 28": 43,
                "l / 30": 46,
                "xl / 32": 49,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 144,
                "s / 26": 146,
                "m / 28": 148,
                "l / 30": 150,
                "xl / 32": 152,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "POLO SHIRT",
          "Category_fr": "POLO",
          "Name": "Le Cavaillet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 34,
                "s / 26": 37,
                "m / 28": 40,
                "l / 30": 43,
                "xl / 32": 46,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 50,
                "s / 26": 52,
                "m / 28": 54,
                "l / 30": 56,
                "xl / 32": 58,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Braudel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 63,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Casel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52.5,
                "s / 26": 55.5,
                "m / 28": 58.5,
                "l / 30": 61.5,
                "xl / 32": 64.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Massard",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Jugan",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 46,
                "s / 26": 49,
                "m / 28": 52,
                "l / 30": 55,
                "xl / 32": 58,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 63,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Chabeur",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 44,
                "s / 26": 47,
                "m / 28": 50,
                "l / 30": 53,
                "xl / 32": 56,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 50,
                "s / 26": 52,
                "m / 28": 54,
                "l / 30": 56,
                "xl / 32": 58,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Placide",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 50,
                "s / 26": 53,
                "m / 28": 56,
                "l / 30": 59,
                "xl / 32": 62,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 60,
                "s / 26": 62,
                "m / 28": 64,
                "l / 30": 66,
                "xl / 32": 68,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Flachat",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 44.5,
                "s / 26": 47.5,
                "m / 28": 50.5,
                "l / 30": 53.5,
                "xl / 32": 56.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 86,
                "s / 26": 88,
                "m / 28": 90,
                "l / 30": 92,
                "xl / 32": 94,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Psichari",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 33,
                "s / 26": 36,
                "m / 28": 39,
                "l / 30": 42,
                "xl / 32": 45,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 138,
                "s / 26": 140,
                "m / 28": 142,
                "l / 30": 144,
                "xl / 32": 146,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "L'Écuries",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 33,
                "s / 29": 36,
                "m / 31": 39,
                "l / 33": 42,
                "xl / 35": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 45,
                "s / 29": 45,
                "m / 31": 46,
                "l / 33": 46,
                "xl / 35": 47
              }
            }
          ]
        },
        {
          "Category": "LINGERIE",
          "Category_fr": "LINGERIE",
          "Name": "La Titon",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 33.5,
                "s / 29": 35.5,
                "m / 31": 37.5,
                "l / 33": 39.5,
                "xl / 35": 41.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 24.5,
                "s / 29": 25.5,
                "m / 31": 26.5,
                "l / 33": 27.5,
                "xl / 35": 28.5
              }
            }
          ]
        },
        {
          "Category": "SHORTS",
          "Category_fr": "SHORTS",
          "Name": "Le Trousseau",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 32.5,
                "s / 29": 34.5,
                "m / 31": 36.5,
                "l / 33": 38.5,
                "xl / 35": 40.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 30,
                "s / 29": 31,
                "m / 31": 32,
                "l / 33": 33,
                "xl / 35": 34
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Bagnolet",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 32,
                "s / 29": 34,
                "m / 31": 36,
                "l / 33": 38,
                "xl / 35": 40
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 104.5,
                "s / 29": 105.5,
                "m / 31": 106.5,
                "l / 33": 107.5,
                "xl / 35": 108.5
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Roquépine",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 30,
                "s / 29": 32,
                "m / 31": 34,
                "l / 33": 36,
                "xl / 35": 38
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 97,
                "s / 29": 98,
                "m / 31": 99,
                "l / 33": 100,
                "xl / 35": 101
              }
            }
          ]
        },
        {
          "Category": "DRESS & SKIRT",
          "Category_fr": "ROBE & JUPE",
          "Name": "La Signac",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 33.5,
                "s / 29": 36.5,
                "m / 31": 39.5,
                "l / 33": 42.5,
                "xl / 35": 45.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 39,
                "s / 29": 40,
                "m / 31": 41,
                "l / 33": 44,
                "xl / 35": 45
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Fondary",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 27": 58,
                "s / 29": 62,
                "m / 31": 66,
                "l / 33": 70,
                "xl / 35": 74
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 27": 102,
                "s / 29": 103,
                "m / 31": 104,
                "l / 33": 105,
                "xl / 35": 106
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Josset",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / s": 64,
                "m / l": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / s": 65.5,
                "m / l": 69.5
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Chaillet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / s": 62,
                "m / l": 68
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / s": 61,
                "m / l": 67
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Citeaux",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / s": 54,
                "m / l": 58
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / s": 67,
                "m / l": 71
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Jossey",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / s": 59,
                "m / l": 61.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / s": 63,
                "m / l": 65
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Chanute",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 48,
                "s / 26": 51,
                "m / 28": 54,
                "l / 30": 57,
                "xl / 32": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 62,
                "s / 26": 64,
                "m / 28": 66,
                "l / 30": 68,
                "xl / 32": 70
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 61,
                "s / 26": 62,
                "m / 28": 63,
                "l / 30": 64,
                "xl / 32": 65
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Patenne",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 57,
                "s / 26": 59,
                "m / 28": 61,
                "l / 30": 63,
                "xl / 32": 65
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 53.5,
                "s / 26": 55.5,
                "m / 28": 57.5,
                "l / 30": 59.5,
                "xl / 32": 61.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 60.5,
                "s / 26": 61.5,
                "m / 28": 62.5,
                "l / 30": 63.5,
                "xl / 32": 64.5
              }
            }
          ]
        },
        {
          "Category": "DRESS",
          "Category_fr": "ROBE",
          "Name": "La Vergennes",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 51,
                "s / 26": 53,
                "m / 28": 55,
                "l / 30": 57,
                "xl / 32": 59
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 83,
                "s / 26": 85,
                "m / 28": 87,
                "l / 30": 89,
                "xl / 32": 91
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 60,
                "s / 26": 61,
                "m / 28": 62,
                "l / 30": 63,
                "xl / 32": 64
              }
            }
          ]
        },
        {
          "Category": "DRESS",
          "Category_fr": "ROBE",
          "Name": "La Judlin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 55,
                "s / 26": 58,
                "m / 28": 61,
                "l / 30": 64,
                "xl / 32": 67
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 90,
                "s / 26": 92,
                "m / 28": 94,
                "l / 30": 96,
                "xl / 32": 98
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 62,
                "s / 26": 63,
                "m / 28": 64,
                "l / 30": 65,
                "xl / 32": 66
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Rajman",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 49.5,
                "s / 26": 52.5,
                "m / 28": 55.5,
                "l / 30": 58.5,
                "xl / 32": 61.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 58,
                "s / 26": 59,
                "m / 28": 60,
                "l / 30": 61,
                "xl / 32": 62
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 59.5,
                "s / 26": 60,
                "m / 28": 60.5,
                "l / 30": 61,
                "xl / 32": 61.5
              }
            }
          ]
        },
        {
          "Category": "SHORTS",
          "Category_fr": "SHORTS",
          "Name": "Le Vermenouze",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 34,
                "s / 26": 36,
                "m / 28": 38,
                "l / 30": 40,
                "xl / 32": 42
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 36.5,
                "s / 26": 37,
                "m / 28": 37.5,
                "l / 30": 38,
                "xl / 32": 38.5
              }
            }
          ]
        },
        
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Focillion",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xxs / 24": null,
                "xs / 25": null,
                "s / 26": null,
                "m / 27": null,
                "l / 28": null,
                "xl / 29": null,
                "xxl / 30": null
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs / 24": null,
                " xs / 25": null,
                "s / 26": null,
                "m / 27": null,
                "l / 28": null,
                "xl / 29": null,
                "xxl / 30": null
              }
            }
          ]
        },
        {
          "Category": "POLO SHIRT",
          "Category_fr": "POLO",
          "Name": "L'Agar",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 34,
                "s / 26": 37,
                "m / 28": 40,
                "l / 30": 43,
                "xl / 32": 46,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 47.5,
                "s / 26": 49.5,
                "m / 28": 51.5,
                "l / 30": 53.5,
                "xl / 32": 55.5,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Bombois",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 35.5,
                "s / 26": 38.5,
                "m / 28": 41.5,
                "l / 30": 44.5,
                "xl / 32": 47.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 68,
                "xl / 32": 60,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Placide",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 50,
                "s / 26": 53,
                "m / 28": 56,
                "l / 30": 59,
                "xl / 32": 62,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 60,
                "s / 26": 62,
                "m / 28": 64,
                "l / 30": 66,
                "xl / 32": 68,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Cepre",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52.5,
                "s / 26": 55.5,
                "m / 28": 58.5,
                "l / 30": 61.5,
                "xl / 32": 64.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Chanez",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 44,
                "s / 26": 46,
                "m / 28": 48,
                "l / 30": 50,
                "xl / 32": 52,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 58,
                "xl / 32": 60,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Changarnier",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 49,
                "s / 26": 51,
                "m / 28": 53,
                "l / 30": 55,
                "xl / 32": 57,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 58,
                "s / 26": 60,
                "m / 28": 62,
                "l / 30": 64,
                "xl / 32": 66,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Bernier",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 48,
                "s / 26": 50,
                "m / 28": 52,
                "l / 30": 54,
                "xl / 32": 56,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 58,
                "s / 26": 60,
                "m / 28": 62,
                "l / 30": 64,
                "xl / 32": 66,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Divry",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 46.5,
                "s / 26": 49.5,
                "m / 28": 52.5,
                "l / 30": 55.5,
                "xl / 32": 58.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 63,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Dupuis",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 55.5,
                "s / 26": 57,
                "m / 28": 58.5,
                "l / 30": 60,
                "xl / 32": 61.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 63.5,
                "s / 26": 65.5,
                "m / 28": 67.5,
                "l / 30": 69.5,
                "xl / 32": 71.5,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Friedel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 49,
                "s / 26": 51,
                "m / 28": 53,
                "l / 30": 55,
                "xl / 32": 57,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 60,
                "s / 26": 62,
                "m / 28": 64,
                "l / 30": 66,
                "xl / 32": 68,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Moureu",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 52.5,
                "s / 26": 54,
                "m / 28": 55.5,
                "l / 30": 57,
                "xl / 32": 58.5,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Laubat",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 51,
                "s / 26": 53,
                "m / 28": 55,
                "l / 30": 57,
                "xl / 32": 59,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Chauchat",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 51,
                "s / 26": 54,
                "m / 28": 57,
                "l / 30": 60,
                "xl / 32": 63,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 54,
                "s / 26": 56,
                "m / 28": 58,
                "l / 30": 60,
                "xl / 32": 62,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Buzelin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 24": 62,
                "s / 26": 65,
                "m / 28": 68,
                "l / 30": 71,
                "xl / 32": 74,
                "xxl": null
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 24": 54,
                "s / 26": 56,
                "m / 28": 58,
                "l / 30": 60,
                "xl / 32": 62,
                "xxl": null
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Ginoux",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 59,
                "xl / 32": 62
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 72,
                "s / 26": 73,
                "m / 28": 74,
                "l / 30": 75,
                "xl / 32": 76
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 60.5,
                "s / 26": 61,
                "m / 28": 61.5,
                "l / 30": 62,
                "xl / 32": 62.5
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Dubail",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 42,
                "s / 26": 44,
                "m / 28": 46,
                "l / 30": 48,
                "xl / 32": 50
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 56.5,
                "s / 26": 57,
                "m / 28": 57.5,
                "l / 30": 58,
                "xl / 32": 58.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "TOP",
          "Category_fr": "TOP",
          "Name": "Le Brèche",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 48,
                "s / 26": 50,
                "m / 28": 52,
                "l / 30": 54,
                "xl / 32": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 46,
                "s / 26": 47,
                "m / 28": 48,
                "l / 30": 49,
                "xl / 32": 50
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 21,
                "s / 26": 22,
                "m / 28": 23,
                "l / 30": 24,
                "xl / 32": 25
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Mandel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 53,
                "s / 26": 55,
                "m / 28": 57,
                "l / 30": 59,
                "xl / 32": 61
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 59,
                "s / 26": 61,
                "m / 28": 63,
                "l / 30": 65,
                "xl / 32": 67
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": 15.5,
                "s / 26": 16,
                "m / 28": 16.5,
                "l / 30": 17,
                "xl / 32": 17.5
              }
            }
          ]
        },
        {
          "Category": "DRESS",
          "Category_fr": "ROBE",
          "Name": "La Niessel",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 32,
                "s / 26": 34,
                "m / 28": 36,
                "l / 30": 38,
                "xl / 32": 40
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 138,
                "s / 26": 139,
                "m / 28": 140,
                "l / 30": 141,
                "xl / 32": 142
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "DRESS",
          "Category_fr": "ROBE",
          "Name": "La Mangin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 29,
                "s / 26": 31,
                "m / 28": 33,
                "l / 30": 35,
                "xl / 32": 37
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 117,
                "s / 26": 118,
                "m / 28": 119,
                "l / 30": 120,
                "xl / 32": 121
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "DRESS",
          "Category_fr": "ROBE",
          "Name": "La Cresson",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 37,
                "s / 26": 39,
                "m / 28": 41,
                "l / 30": 43,
                "xl / 32": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 147,
                "s / 26": 148,
                "m / 28": 149,
                "l / 30": 150,
                "xl / 32": 151
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Boyer",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xs / 24": 44,
                "s / 26": 46,
                "m / 28": 48,
                "l / 30": 50,
                "xl / 32": 52
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 55,
                "s / 26": 56,
                "m / 28": 57,
                "l / 30": 58,
                "xl / 32": 59
              }
            },
            {
              "Longueur de manches (cm)": {
                "xs / 24": null,
                "s / 26": null,
                "m / 28": null,
                "l / 30": null,
                "xl / 32": null
              }
            }
          ]
        },
        {
          "Category": "SHORTS",
          "Category_fr": "SHORTS",
          "Name": "Le Dussane",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 31,
                "s / 26": 32,
                "m / 28": 33,
                "l / 30": 34,
                "xl / 32": 35
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 43.5,
                "s / 26": 44,
                "m / 28": 44.5,
                "l / 30": 45,
                "xl / 32": 45.5
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Vauvenargue",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xxs / 24": 30,
                "xs / 25": 32,
                "s / 26": 34,
                "m / 27": 36,
                "l / 28": 38,
                "xl / 29": 40,
                "xxl / 30": 42
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs / 24": 112,
                "xs / 25": 113,
                "s / 26": 114,
                "m / 27": 115,
                "l / 28": 116,
                "xl / 29": 117,
                "xxl / 30": 118
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Chevreuil",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xxs / 24": 32,
                "xs / 25": 34,
                "s / 26": 37,
                "m / 27": 39,
                "l / 28": null,
                "xl / 29": null,
                "xxl / 30": null
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs / 24": null,
                "xs / 25": 114,
                "s / 26": 115,
                "m / 27": 115,
                "l / 28": 116,
                "xl / 29": 116,
                "xxl / 30": null
              }
            }
          ]
        },
        {
          "Category": "CARDIGAN",
          "Category_fr": "CARDIGAN",
          "Name": "Le Tolbiac Pointelle",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 44,
                "s / 26": 47,
                "m / 28": 50,
                "l / 30": 53,
                "xl / 32": 56
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 49.5,
                "s / 26": 51.5,
                "m / 28": 53.5,
                "l / 30": 55.5,
                "xl / 32": 57.5
              }
            }
          ]
        },
        {
          "Category": "CARDIGAN",
          "Category_fr": "CARDIGAN",
          "Name": "Le Cardinoux",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 44.5,
                "s / 26": 47.5,
                "m / 28": 50.5,
                "l / 30": 53.5,
                "xl / 32": 56.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 47,
                "s / 26": 49,
                "m / 28": 51,
                "l / 30": 53,
                "xl / 32": 55
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Folies Pointelle",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 36,
                "s / 26": 39,
                "m / 28": 42,
                "l / 30": 45,
                "xl / 32": 48
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 54,
                "s / 26": 56,
                "m / 28": 58,
                "l / 30": 60,
                "xl / 32": 62
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Goyon",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 52,
                "s / 26": 55,
                "m / 28": 58,
                "l / 30": 61,
                "xl / 32": 64
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 64
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Cepre",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 52.5,
                "s / 26": 55.5,
                "m / 28": 58.5,
                "l / 30": 61.5,
                "xl / 32": 64.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Mithouard",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 42,
                "s / 26": 45,
                "m / 28": 48,
                "l / 30": 51,
                "xl / 32": 54
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 58,
                "xl / 32": 60
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Fautrier",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 63,
                "s / 26": 65,
                "m / 28": 67,
                "l / 30": 69,
                "xl / 32": 71
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 54,
                "s / 26": 56,
                "m / 28": 58,
                "l / 30": 60,
                "xl / 32": 62
              }
            }
          ]
        },
        {
          "Category": "SLEEVELESS SWEATER",
          "Category_fr": "PULL SANS MANCHE",
          "Name": "Le Lafay",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 41,
                "s / 26": 44,
                "m / 28": 47,
                "l / 30": 50,
                "xl / 32": 53
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 37,
                "s / 26": 40,
                "m / 28": 43,
                "l / 30": 46,
                "xl / 32": 49
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Cerisoles",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 63,
                "s / 26": 65,
                "m / 28": 67,
                "l / 30": 69,
                "xl / 32": 71
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 54,
                "s / 26": 56,
                "m / 28": 58,
                "l / 30": 60,
                "xl / 32": 62
              }
            }
          ]
        },
        {
          "Category": "CARDIGAN",
          "Category_fr": "CARDIGAN",
          "Name": "Le Liouville",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 52,
                "s / 26": 54,
                "m / 28": 56,
                "l / 30": 58,
                "xl / 32": 60
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 49,
                "s / 26": 51,
                "m / 28": 53,
                "l / 30": 55,
                "xl / 32": 57
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Champaubert",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 52.5,
                "s / 26": 54,
                "m / 28": 55.5,
                "l / 30": 57,
                "xl / 32": 58.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 56,
                "s / 26": 58,
                "m / 28": 60,
                "l / 30": 62,
                "xl / 32": 64
              }
            }
          ]
        },
        {
          "Category": "CARDIGAN",
          "Category_fr": "CARDIGAN",
          "Name": "Le Glizière",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / 24": 47,
                "s / 26": 49,
                "m / 28": 51,
                "l / 30": 53,
                "xl / 32": 55
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / 24": 55,
                "s / 26": 57,
                "m / 28": 59,
                "l / 30": 61,
                "xl / 32": 63
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Beaufort",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 27": 42,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 49,
                "xl / 35": 52,
                "xxl": 54
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 27": null,
                "s / 29": null,
                "m / 31": null,
                "l / 33": null,
                "xl / 35": null,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 27": 75,
                "s / 29": 77,
                "m / 31": 78,
                "l / 33": 79,
                "xl / 35": 80,
                "xxl": 91
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "L'Acorn",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 27": 42,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 49,
                "xl / 35": 52,
                "xxl": 54
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 27": null,
                "s / 29": null,
                "m / 31": null,
                "l / 33": null,
                "xl / 35": null,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 27": 75,
                "s / 29": 77,
                "m / 31": 78,
                "l / 33": 79,
                "xl / 35": 80,
                "xxl": 91
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Loudon",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": null,
                "xs / 27": 42,
                "s / 29": 44,
                "m / 31": 47,
                "l / 33": 49,
                "xl / 35": 52,
                "xxl": 54
              }
            },
            {
              "Longueur total (cm)": {
                "xxs": null,
                "xs / 27": null,
                "s / 29": null,
                "m / 31": null,
                "l / 33": null,
                "xl / 35": null,
                "xxl": null
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": null,
                "xs / 27": 75,
                "s / 29": 77,
                "m / 31": 78,
                "l / 33": 79,
                "xl / 35": 80,
                "xxl": 91
              }
            }
          ]
        }
      ],
      unisex: [
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Popincourt",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 43.5,
                "xs / 27": 46.5,
                "s / 29": 49.5,
                "m / 31": 53.5,
                "l / 33": 56.5,
                "xl / 35": 59.5,
                "xxl": 62.5
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 64,
                "xs / 27": 67,
                "s / 29": 69,
                "m / 31": 72,
                "l / 33": 74,
                "xl / 35": 77,
                "xxl": 80
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Répu",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 48,
                "xs / 27": 51,
                "s / 29": 54,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64,
                "xxl": 67
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 64,
                "xs / 27": 67,
                "s / 29": 69,
                "m / 31": 72,
                "l / 33": 74,
                "xl / 35": 77,
                "xxl": 80
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Ledru",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 48.5,
                "xs / 27": 52.5,
                "s / 29": 56,
                "m / 31": 59,
                "l / 33": 62,
                "xl / 35": 65,
                "xxl": 68
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 64,
                "xs / 27": 67,
                "s / 29": 69,
                "m / 31": 71,
                "l / 33": 73,
                "xl / 35": 75,
                "xxl": 77
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Placide",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 49.5,
                "xs / 27": 53.5,
                "s / 29": 57,
                "m / 31": 60,
                "l / 33": 63,
                "xl / 35": 66,
                "xxl": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 64,
                "xs / 27": 67,
                "s / 29": 69,
                "m / 31": 71,
                "l / 33": 73,
                "xl / 35": 75,
                "xxl": 77
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Réaumur",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 49.5,
                "xs / 27": 53.5,
                "s / 29": 57,
                "m / 31": 60,
                "l / 33": 63,
                "xl / 35": 66,
                "xxl": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 64,
                "xs / 27": 67,
                "s / 29": 69,
                "m / 31": 71,
                "l / 33": 73,
                "xl / 35": 75,
                "xxl": 77
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Troca",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": "-",
                "xs / 27": 60,
                "s / 29": 63,
                "m / 31": 66,
                "l / 33": 69,
                "xl / 35": 72,
                "xxl": 75
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": "-",
                "xs / 27": 66,
                "s / 29": 69,
                "m / 31": 72,
                "l / 33": 75,
                "xl / 35": 78,
                "xxl": 81
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Sébasto",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 52,
                "xs / 27": 55,
                "s / 29": 58,
                "m / 31": 61,
                "l / 33": 64,
                "xl / 35": 67,
                "xxl": 70
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 71,
                "xs / 27": 72,
                "s / 29": 73,
                "m / 31": 74,
                "l / 33": 75,
                "xl / 35": 76,
                "xxl": 77
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": 63,
                "xs / 27": 64,
                "s / 29": 65,
                "m / 31": 66,
                "l / 33": 67,
                "xl / 35": 68,
                "xxl": 69
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Breteuil",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": "-",
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64,
                "xxl": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": "-",
                "xs / 27": 75,
                "s / 29": 77,
                "m / 31": 79,
                "l / 33": 81,
                "xl / 35": 83,
                "xxl": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": 63,
                "s / 29": 64,
                "m / 31": 65,
                "l / 33": 66,
                "xl / 35": 67,
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Messine",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 53,
                "xs / 27": 55,
                "s / 29": 57,
                "m / 31": 60,
                "l / 33": 63,
                "xl / 35": 66,
                "xxl": 69
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 62,
                "xs / 27": 65,
                "s / 29": 68,
                "m / 31": 70,
                "l / 33": 72,
                "xl / 35": 74,
                "xxl": 76
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": "-",
                "xs / 27": "-",
                "s / 29": "-",
                "m / 31": "-",
                "l / 33": "-",
                "xl / 35": "-",
                "xxl": "-"
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "La Lancereaux",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "xxs": 49,
                "xs / 27": 52,
                "s / 29": 55,
                "m / 31": 58,
                "l / 33": 61,
                "xl / 35": 64,
                "xxl": 67
              }
            },
            {
              "Longueur devant (cm)": {
                "xxs": 70,
                "xs / 27": 72,
                "s / 29": 74,
                "m / 31": 76,
                "l / 33": 78,
                "xl / 35": 80,
                "xxl": 82
              }
            },
            {
              "Longueur de manches (cm)": {
                "xxs": 60,
                "xs / 27": 61,
                "s / 29": 62,
                "m / 31": 63,
                "l / 33": 64,
                "xl / 35": 65,
                "xxl": 66
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Trésor",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / m": 35,
                "m / l": 37,
                "xl / xxl": 39
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / m": 101,
                "m / l": 103,
                "xl / xxl": 105
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Duperré",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "xs / m": 32,
                "m / l": 34,
                "xl / xxl": 36
              }
            },
            {
              "Longueur devant (cm)": {
                "xs / m": 46,
                "m / l": 48,
                "xl / xxl": 50
              }
            }
          ]
        },
        {
          "Category": "BANDANA",
          "Category_fr": "BANDANA",
          "Name": "La Lampué",
          "sizes": [
            {
              "size": {
                "size": "format carré 55X55cm"
              }
            }
          ]
        },
        {
          "Category": "BANDANA",
          "Category_fr": "BANDANA",
          "Name": "Le Brancion",
          "sizes": [
            {
              "size": {
                "size": "format carré 70X70cm"
              }
            }
          ]
        },
        {
          "Category": "BAG",
          "Category_fr": "BAG",
          "Name": "Ozanam",
          "sizes": [
            {
              "size": {
                "Hauteur": "35 cm",
                "Longueur": "48,5 cm",
                "Profondeur": "10,5 cm"
              }
            }
          ]
        },
        {
          "Category": "BAG",
          "Category_fr": "BAG",
          "Name": "Morard",
          "sizes": [
            {
              "size": {
                "Hauteur": "46 cm",
                "Longueur": "37 cm",
                "Profondeur": "20 cm"
              }
            }
          ]
        },
        {
          "Category": "BAG",
          "Category_fr": "BAG",
          "Name": "Lobineau",
          "sizes": [
            {
              "size": {
                "Hauteur": "34 cm",
                "Longueur": "46 cm",
                "Profondeur": "21 cm"
              }
            }
          ]
        }
      ],
      kids: [
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Bresse",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 31.5,
                "4 a": 33.5,
                "6 a": 35.5,
                "8 a": 37.5,
                "10 a": 39.5,
                "12 a": 41.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 41,
                "4 a": 44,
                "6 a": 47,
                "8 a": 50,
                "10 a": 53,
                "12 a": 56
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "PYJAMA",
          "Category_fr": "COMBI",
          "Name": "Le Bartholome",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 25,
                "3 / 6 m": 27,
                "6 / 12 m": 29,
                "12 / 18 m": 31,
                "18 / 24 m": 33,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 45,
                "3 / 6 m": 48,
                "6 / 12 m": 51,
                "12 / 18 m": 54,
                "18 / 24 m": 57,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Aliscamps Pointelle",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 21.5,
                "3 / 6 m": 23.5,
                "6 / 12 m": 25.5,
                "12 / 18 m": 27.5,
                "18 / 24 m": 29.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 23,
                "3 / 6 m": 26,
                "6 / 12 m": 29,
                "12 / 18 m": 32,
                "18 / 24 m": 35,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Aliscamps Rayé",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 22,
                "3 / 6 m": 24,
                "6 / 12 m": 26,
                "12 / 18 m": 28,
                "18 / 24 m": 30,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 23.5,
                "3 / 6 m": 26.5,
                "6 / 12 m": 29.5,
                "12 / 18 m": 32.5,
                "18 / 24 m": 35.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Alboni",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 23.5,
                "3 / 6 m": 25.5,
                "6 / 12 m": 27.5,
                "12 / 18 m": 29.5,
                "18 / 24 m": 31.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 46,
                "3 / 6 m": 50,
                "6 / 12 m": 54,
                "12 / 18 m": 58,
                "18 / 24 m": 62,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Gardette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 23.5,
                "3 / 6 m": 25.5,
                "6 / 12 m": 27.5,
                "12 / 18 m": 29.5,
                "18 / 24 m": 31.5,
                "2 a": 28,
                "4 a": 30,
                "6 a": 32,
                "8 a": 34,
                "10 a": 36,
                "12 a": 38
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 24,
                "3 / 6 m": 27,
                "6 / 12 m": 30,
                "12 / 18 m": 33,
                "18 / 24 m": 36,
                "2 a": 36,
                "4 a": 39,
                "6 a": 42,
                "8 a": 45,
                "10 a": 48,
                "12 a": 51
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Moulin",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 25,
                "3 / 6 m": 27,
                "6 / 12 m": 29,
                "12 / 18 m": 31,
                "18 / 24 m": 33,
                "2 a": 34,
                "4 a": 36,
                "6 a": 38,
                "8 a": 40,
                "10 a": 42,
                "12 a": 44
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 26,
                "3 / 6 m": 29,
                "6 / 12 m": 32,
                "12 / 18 m": 35,
                "18 / 24 m": 38,
                "2 a": 36,
                "4 a": 39,
                "6 a": 42,
                "8 a": 45,
                "10 a": 48,
                "12 a": 51
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "T-SHIRT",
          "Category_fr": "TEE-SHIRT",
          "Name": "Le Léon",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 23.5,
                "3 / 6 m": 25.5,
                "6 / 12 m": 27.5,
                "12 / 18 m": 29.5,
                "18 / 24 m": 31.5,
                "2 a": 28,
                "4 a": 30,
                "6 a": 32,
                "8 a": 34,
                "10 a": 36,
                "12 a": 38
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 25,
                "3 / 6 m": 28,
                "6 / 12 m": 31,
                "12 / 18 m": 34,
                "18 / 24 m": 37,
                "2 a": 38.5,
                "4 a": 41.5,
                "6 a": 44.5,
                "8 a": 47.5,
                "10 a": 50.5,
                "12 a": 53.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Pereire",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 26,
                "3 / 6 m": 28,
                "6 / 12 m": 30,
                "12 / 18 m": 32,
                "18 / 24 m": 34,
                "2 a": 34,
                "4 a": 36,
                "6 a": 38,
                "8 a": 40,
                "10 a": 42,
                "12 a": 44
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 25,
                "3 / 6 m": 28,
                "6 / 12 m": 30,
                "12 / 18 m": 33,
                "18 / 24 m": 36,
                "2 a": 35,
                "4 a": 38,
                "6 a": 41,
                "8 a": 44,
                "10 a": 47,
                "12 a": 50
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Viviani",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 25,
                "3 / 6 m": 27,
                "6 / 12 m": 29,
                "12 / 18 m": 31,
                "18 / 24 m": 33,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 23,
                "3 / 6 m": 26,
                "6 / 12 m": 29,
                "12 / 18 m": 32,
                "18 / 24 m": 35,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Calmette",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 19,
                "3 / 6 m": 21,
                "6 / 12 m": 23,
                "12 / 18 m": 25,
                "18 / 24 m": 27,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 42,
                "3 / 6 m": 44,
                "6 / 12 m": 46,
                "12 / 18 m": 48,
                "18 / 24 m": 50,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SAILOR SHIRT",
          "Category_fr": "MARINIÈRE",
          "Name": "La Blomet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 18,
                "3 / 6 m": 20,
                "6 / 12 m": 22,
                "12 / 18 m": 24,
                "18 / 24 m": 26,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 36,
                "3 / 6 m": 38,
                "6 / 12 m": 40,
                "12 / 18 m": 42,
                "18 / 24 m": 44,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Malo",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 19,
                "3 / 6 m": 21,
                "6 / 12 m": 23,
                "12 / 18 m": 25,
                "18 / 24 m": 27,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 42,
                "3 / 6 m": 44,
                "6 / 12 m": 46,
                "12 / 18 m": 48,
                "18 / 24 m": 50,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Dauphine",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 16.5,
                "3 / 6 m": 18.5,
                "6 / 12 m": 20.5,
                "12 / 18 m": 22.5,
                "18 / 24 m": 24.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 37,
                "3 / 6 m": 39,
                "6 / 12 m": 41,
                "12 / 18 m": 43,
                "18 / 24 m": 47,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Lamartine",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 19,
                "3 / 6 m": 21,
                "6 / 12 m": 25,
                "12 / 18 m": 27,
                "18 / 24 m": 29,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 37,
                "3 / 6 m": 39,
                "6 / 12 m": 43,
                "12 / 18 m": 45,
                "18 / 24 m": 47,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Dodu",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 19,
                "3 / 6 m": 21,
                "6 / 12 m": 23,
                "12 / 18 m": 25,
                "18 / 24 m": 27,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 42,
                "3 / 6 m": 21,
                "6 / 12 m": 23,
                "12 / 18 m": 25,
                "18 / 24 m": 27,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "L'Éole",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 19,
                "3 / 6 m": 21,
                "6 / 12 m": 23,
                "12 / 18 m": 25,
                "18 / 24 m": 27,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 39,
                "3 / 6 m": 41,
                "6 / 12 m": 43,
                "12 / 18 m": 45,
                "18 / 24 m": 47,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATSHIRT",
          "Category_fr": "SWEATSHIRT",
          "Name": "Le Plantes",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 35,
                "4 a": 37,
                "6 a": 39,
                "8 a": 41,
                "10 a": 43,
                "12 a": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 37.5,
                "4 a": 40.5,
                "6 a": 43.5,
                "8 a": 46.5,
                "10 a": 49.5,
                "12 a": 52.5
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Cadet",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 33.5,
                "4 a": 35.5,
                "6 a": 37.5,
                "8 a": 39.5,
                "10 a": 41.5,
                "12 a": 43.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 37,
                "4 a": 40,
                "6 a": 43,
                "8 a": 46,
                "10 a": 49,
                "12 a": 52
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Daumesnil",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 33.5,
                "4 a": 35.5,
                "6 a": 37.5,
                "8 a": 39.5,
                "10 a": 41.5,
                "12 a": 43.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 37,
                "4 a": 40,
                "6 a": 43,
                "8 a": 46,
                "10 a": 49,
                "12 a": 52
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Palikao",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 34,
                "4 a": 36,
                "6 a": 38,
                "8 a": 40,
                "10 a": 42,
                "12 a": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 38,
                "4 a": 42,
                "6 a": 46,
                "8 a": 50,
                "10 a": 54,
                "12 a": 58
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 31.5,
                "4 a": 36,
                "6 a": 39.5,
                "8 a": 44,
                "10 a": 47.5,
                "12 a": 51
              }
            }
          ]
        },
        {
          "Category": "JACKET",
          "Category_fr": "VESTE",
          "Name": "L'Amandiers",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 35,
                "4 a": 37,
                "6 a": 39,
                "8 a": 41,
                "10 a": 43,
                "12 a": 45
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 42,
                "4 a": 45,
                "6 a": 48,
                "8 a": 51,
                "10 a": 54,
                "12 a": 57
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 32,
                "4 a": 36,
                "6 a": 40,
                "8 a": 44,
                "10 a": 48,
                "12 a": 52
              }
            }
          ]
        },
        {
          "Category": "SHIRT",
          "Category_fr": "CHEMISE",
          "Name": "La Paturle",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 34,
                "4 a": 36,
                "6 a": 38,
                "8 a": 40,
                "10 a": 42,
                "12 a": 44
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 38,
                "4 a": 42,
                "6 a": 46,
                "8 a": 50,
                "10 a": 54,
                "12 a": 58
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 33,
                "4 a": 37,
                "6 a": 41,
                "8 a": 45,
                "10 a": 49,
                "12 a": 53
              }
            }
          ]
        },
        {
          "Category": "SWEATER",
          "Category_fr": "PULL",
          "Name": "Le Bulher",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 33.5,
                "4 a": 35.5,
                "6 a": 37.5,
                "8 a": 39.5,
                "10 a": 41.5,
                "12 a": 43.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 37,
                "4 a": 40,
                "6 a": 43,
                "8 a": 46,
                "10 a": 49,
                "12 a": 52
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 33,
                "4 a": 35.5,
                "6 a": 38,
                "8 a": 40.5,
                "10 a": 43,
                "12 a": 45.5
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Morisot",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 23.5,
                "3 / 6 m": 25.5,
                "6 / 12 m": 27.5,
                "12 / 18 m": 29.5,
                "18 / 24 m": 31.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 46,
                "3 / 6 m": 50,
                "6 / 12 m": 54,
                "12 / 18 m": 58,
                "18 / 24 m": 62,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Quintinie",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 23,
                "3 / 6 m": 25,
                "6 / 12 m": 27,
                "12 / 18 m": 29,
                "18 / 24 m": 31,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 49,
                "3 / 6 m": 52,
                "6 / 12 m": 55,
                "12 / 18 m": 58,
                "18 / 24 m": 61,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Cain",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 18,
                "3 / 6 m": 20,
                "6 / 12 m": 22,
                "12 / 18 m": 24,
                "18 / 24 m": 26,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 38,
                "3 / 6 m": 40,
                "6 / 12 m": 42,
                "12 / 18 m": 44,
                "18 / 24 m": 46,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Marigny",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 18,
                "3 / 6 m": 20,
                "6 / 12 m": 22,
                "12 / 18 m": 24,
                "18 / 24 m": 26,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 36,
                "3 / 6 m": 38,
                "6 / 12 m": 40,
                "12 / 18 m": 42,
                "18 / 24 m": 44,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "ONESIE",
          "Category_fr": "BODY POUR BÉBÉ",
          "Name": "Le Pépinière",
          "sizes": [
            {
              "Demi-tour de poitrine (cm à plat)": {
                "0 / 3 m": 24.5,
                "3 / 6 m": 26.5,
                "6 / 12 m": 28.5,
                "12 / 18 m": 30.5,
                "18 / 24 m": 32.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 44,
                "3 / 6 m": 47,
                "6 / 12 m": 50,
                "12 / 18 m": 53,
                "18 / 24 m": 56,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur de manches (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Bresse (Pants)",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 18.5,
                "4 a": 20.5,
                "6 a": 22.5,
                "8 a": 24.5,
                "10 a": 26.5,
                "12 a": 28.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 50,
                "4 a": 58,
                "6 a": 66,
                "8 a": 74,
                "10 a": 82,
                "12 a": 90
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Adanson",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": 34,
                "3 / 6 m": 36,
                "6 / 12 m": 38,
                "12 / 18 m": 40,
                "18 / 24 m": 42,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 30,
                "3 / 6 m": 31.5,
                "6 / 12 m": 33,
                "12 / 18 m": 34.5,
                "18 / 24 m": 36,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Trésor",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": 15.5,
                "3 / 6 m": 17,
                "6 / 12 m": 18.5,
                "12 / 18 m": 20,
                "18 / 24 m": 21.5,
                "2 a": 22,
                "4 a": 24,
                "6 a": 26,
                "8 a": 28,
                "10 a": 30,
                "12 a": 32
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 25,
                "3 / 6 m": 28,
                "6 / 12 m": 31,
                "12 / 18 m": 34,
                "18 / 24 m": 37,
                "2 a": 46,
                "4 a": 54,
                "6 a": 62,
                "8 a": 70,
                "10 a": 78,
                "12 a": 86
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Duperré",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": 19,
                "3 / 6 m": 20,
                "6 / 12 m": 21,
                "12 / 18 m": 22,
                "18 / 24 m": 23,
                "2 a": 22,
                "4 a": 24,
                "6 a": 26,
                "8 a": 28,
                "10 a": 30,
                "12 a": 32
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 16.5,
                "3 / 6 m": 18,
                "6 / 12 m": 19.5,
                "12 / 18 m": 21,
                "18 / 24 m": 22.5,
                "2 a": 24,
                "4 a": 26,
                "6 a": 28,
                "8 a": 30,
                "10 a": 32,
                "12 a": 34
              }
            }
          ]
        },
        {
          "Category": "SWIM SHORTS",
          "Category_fr": "SHORT DE BAIN",
          "Name": "Le Maillot",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 22,
                "4 a": 23.5,
                "6 a": 25,
                "8 a": 26.5,
                "10 a": 28,
                "12 a": 29.5
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 20.5,
                "4 a": 23.5,
                "6 a": 25.5,
                "8 a": 28,
                "10 a": 31.5,
                "12 a": 35
              }
            }
          ]
        },
        {
          "Category": "SWIM SHORTS",
          "Category_fr": "SHORT DE BAIN",
          "Name": "Le Galant",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 22,
                "4 a": 24,
                "6 a": 26,
                "8 a": 28,
                "10 a": 30,
                "12 a": 32
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": "-",
                "3 / 6 m": "-",
                "6 / 12 m": "-",
                "12 / 18 m": "-",
                "18 / 24 m": "-",
                "2 a": 20.5,
                "4 a": 23.5,
                "6 a": 25.5,
                "8 a": 28,
                "10 a": 31.5,
                "12 a": 35
              }
            }
          ]
        },
        {
          "Category": "PANTS",
          "Category_fr": "PANTALON",
          "Name": "Le Récamier",
          "sizes": [
            {
              "Tour de taille (cm)": {
                "0 / 3 m": 15.5,
                "3 / 6 m": 17,
                "6 / 12 m": 18.5,
                "12 / 18 m": 20,
                "18 / 24 m": 21.5,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            },
            {
              "Longueur devant (cm)": {
                "0 / 3 m": 25,
                "3 / 6 m": 28,
                "6 / 12 m": 31,
                "12 / 18 m": 34,
                "18 / 24 m": 37,
                "2 a": "-",
                "4 a": "-",
                "6 a": "-",
                "8 a": "-",
                "10 a": "-",
                "12 a": "-"
              }
            }
          ]
        }
      ],
  },
];